export const licitaciones = [
  {
    anio: "2023",
    icono: "fa fa-file-text-o fa-2x",
    formatos: [
      [
        "ACTA DE APERTURA CAASIM-HGO-L.O.P.-09-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACTA DE APERTURA CAASIM-HGO-L.O.P.-09-2023.pdf",
        },
      ],
      [
        "ACTA DE APERTURA CAASIM-HGO-L.O.P.-10-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACTA DE APERTURA CAASIM-HGO-L.O.P.-10-2023.pdf",
        },
      ],
      [
        "ACTA DE APERTURA CAASIM-HGO-L.O.P.-11-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACTA DE APERTURA CAASIM-HGO-L.O.P.-11-2023.pdf",
        },
      ],
      [
        "ACTA DE APERTURA DE PROPOSICIONES N74 ADQUISICION DE GRUA CON PLATAFORMA PARA OPERAION EN POZO CON CAPACIDAD DE CARGA DE 30 TONELADAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACTA DE APERTURA DE PROPOSICIONES N74 ADQUISICION DE GRUA CON PLATAFORMA PARA OPERAION EN POZO CON CAPACIDAD DE CARGA DE 30 TONELADAS.pdf",
        },
      ],
      [
        "ACTA DE APERTURA DE PROPOSICIONES N76 SWITCH DE 48 PUERTOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACTA DE APERTURA DE PROPOSICIONES N76 SWITCH DE 48 PUERTOS.pdf",
        },
      ],
      [
        "ACTA DE APERTURA DE PROPOSICIONES N79 ESTUDIOS E INVESTIGACIONES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACTA DE APERTURA DE PROPOSICIONES N79 ESTUDIOS E INVESTIGACIONES.pdf",
        },
      ],
      [
        "ACTA DE APERTURA N43 REFACCIONES MENORES DE EQUIPO DE COMPUTO Y TECNOLOGIAS DE LA INFORMACION",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACTA DE APERTURA N43 REFACCIONES MENORES DE EQUIPO DE COMPUTO Y TECNOLOGIAS DE LA INFORMACION.pdf",
        },
      ],
      [
        "ACTA DE PRESENTACIÓN Y APERTURA EA-913005999-N73-2023 VIDEO VIGILANCIA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACTA DE PRESENTACIÓN Y APERTURA EA-913005999-N73-2023 VIDEO VIGILANCIA.pdf",
        },
      ],
      [
        "ACTA DE REPROGRAMACIÓN DE PRESENTACIÓN Y APERTURA DE PROPOSICIONES DE LAS LICITACIONES EA-913005999-N60-2023 Y EA-913005999-N61-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACTA DE REPROGRAMACIÓN DE PRESENTACIÓN Y APERTURA DE PROPOSICIONES DE LAS LICITACIONES EA-913005999-N60-2023 Y EA-913005999-N61-2023.pdf",
        },
      ],
      [
        "ACTO DE PRESENTACION Y APERTURA DE PROPOSICIONES  EA-913005999-N22-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACTO DE PRESENTACION Y APERTURA DE PROPOSICIONES  EA-913005999-N22-2023.pdf",
        },
      ],
      [
        "ACTO DE PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N66 EQUIPOS Y APARATOS DE COMUNICACIÓN Y TELECOMUNICACIONES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACTO DE PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N66 EQUIPOS Y APARATOS DE COMUNICACIÓN Y TELECOMUNICACIONES.pdf",
        },
      ],
      [
        "ACUERDO PARA DEJAR INSUBSISTENTE EL FALLO EA-913005999-N9-2023 DE FECHA 29 DE MAYO DE 2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/ACUERDO PARA DEJAR INSUBSISTENTE EL FALLO EA-913005999-N9-2023 DE FECHA 29 DE MAYO DE 2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-12-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-12-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-13-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-13-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-14-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-14-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-15-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-15-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-17-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-17-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-18-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-18-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-19-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-19-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-20-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-20-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-21-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-21-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.OP.-16-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.OP.-16-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.OP.-22-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.OP.-22-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N1-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N1-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N2-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N2-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N3-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N3-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N4-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N4-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N5-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N5-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N6-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N6-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N7-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N7-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N8-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N8-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N9-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N9-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N10-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N10-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N11-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N11-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N14-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N14-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N15-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N15-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N30-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N30-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N35-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N35-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N36-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N36-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N37-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N37-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N38-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N38-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N39-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N39-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N40-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N40-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N41-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N41-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N42-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N42-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N61-2023 FIBRAS SINTÉTICAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N61-2023 FIBRAS SINTÉTICAS.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N67-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N67-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N69-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N69-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N70-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N70-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N71-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N71-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N72-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N72-2023.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N87-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N87-2023.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-01-2023_ZONA I",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-01-2023_ZONA I.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-02-2023_ZONA II",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-02-2023_ZONA II.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-03-2023_ZONA III",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-03-2023_ZONA III.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-04-2023_ZONA IV",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-04-2023_ZONA IV.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-05-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-05-2023.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-06-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-06-2023.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-07-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-07-2023.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-08-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-08-2023.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-09-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-09-2023.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-10-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-10-2023.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-11-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-11-2023.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-12-2023_ZONA I (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-12-2023_ZONA I (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-13-2023_ZONA II (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-13-2023_ZONA II (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-14-2023_ZONA III (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-14-2023_ZONA III (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-15-2023_ZONA IV (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-15-2023_ZONA IV (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-16-2023 (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-16-2023 (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-17-2023 SEGUNDO PROCEDIMIENTO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-17-2023 SEGUNDO PROCEDIMIENTO.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-18-2023 SEGUNDO PROCEDIMIENTO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-18-2023 SEGUNDO PROCEDIMIENTO.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-19-2023 (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-19-2023 (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-20-2023 (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-20-2023 (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-21-2023 (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-21-2023 (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-22-2023 (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-22-2023 (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-23-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-23-2023.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-24-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-24-2023.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-25-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-25-2023.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-26-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES CAASIM-HGO-L.O.P.-26-2023.pdf",
        },
      ],
      [
        "BASES EA-913005999-N1-2023 TRASLADO DE VALORES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N1-2023 TRASLADO DE VALORES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N2-2023 CEMENTO Y PRODUCTOS DE CONCRETO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N2-2023 CEMENTO Y PRODUCTOS DE CONCRETO.pdf",
        },
      ],
      [
        "BASES EA-913005999-N3-2023 MATERIAL DE OFICINA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N3-2023 MATERIAL DE OFICINA.pdf",
        },
      ],
      [
        "BASES EA-913005999-N4-2023 MATERIAL DE LIMPIEZA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N4-2023 MATERIAL DE LIMPIEZA.pdf",
        },
      ],
      [
        "BASES EA-913005999-N5-2023 PRODUCTOS MINERALES NO METÁLICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N5-2023 PRODUCTOS MINERALES NO METÁLICOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N6-2023 FLETES Y MANIOBRAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N6-2023 FLETES Y MANIOBRAS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N7-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N7-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N8-2023 CEMENTO Y PRODUCTOS DE CONCRETO (2DO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N8-2023 CEMENTO Y PRODUCTOS DE CONCRETO (2DO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N9-2023 PRODUCTOS MINERALES NO METÁLICOS (2DO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N9-2023 PRODUCTOS MINERALES NO METÁLICOS (2DO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N10-2023 SERVICIO DE LIMPIEZA Y MANEJO DE DESECHOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N10-2023 SERVICIO DE LIMPIEZA Y MANEJO DE DESECHOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N11-2023, VESTUARIO Y\xa0UNIFORMES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N11-2023, VESTUARIO Y\xa0UNIFORMES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N14-2023 SERVICIO DE LIMPIEZA Y MANEJO DE DESECHOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N14-2023 SERVICIO DE LIMPIEZA Y MANEJO DE DESECHOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N15-2023 VESTUARIO Y UNIFORMES (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N15-2023 VESTUARIO Y UNIFORMES (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N16-2023 MOBILIARIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N16-2023 MOBILIARIO.pdf",
        },
      ],
      [
        "BASES EA-913005999-N17-2023 EQUIPOS DE GENERACIÓN ELÉCTRICA, APARATOS Y ACCESORIOS ELÉCTRICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N17-2023 EQUIPOS DE GENERACIÓN ELÉCTRICA, APARATOS Y ACCESORIOS ELÉCTRICOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N18-2023 REFACCIONES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N18-2023 REFACCIONES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N19-2023 ADQUISICIÓN DE PAVIMENTO ASFÁLTICO EN EL MUNICIPIO DE PACHUCA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N19-2023 ADQUISICIÓN DE PAVIMENTO ASFÁLTICO EN EL MUNICIPIO DE PACHUCA.pdf",
        },
      ],
      [
        "BASES EA-913005999-N20-2023 ADQUISICIÓN DE VARIADORES DE VELOCIDAD",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N20-2023 ADQUISICIÓN DE VARIADORES DE VELOCIDAD.pdf",
        },
      ],
      [
        "BASES EA-913005999-N21-2023 ADQUISICIÓN DE EQUIPOS DE BOMBEO PARA POZOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N21-2023 ADQUISICIÓN DE EQUIPOS DE BOMBEO PARA POZOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N22-2023 ESTUDIO DE EFICIENCIA ENERGETICA 52 POZOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N22-2023 ESTUDIO DE EFICIENCIA ENERGETICA 52 POZOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N23-2023 HERRAMIENTAS MENORES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N23-2023 HERRAMIENTAS MENORES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N24-2023 OTROS MATERIALES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N24-2023 OTROS MATERIALES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N25-2023 MAQUINARIA Y EQUIPO INDUSTRIAL",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N25-2023 MAQUINARIA Y EQUIPO INDUSTRIAL.pdf",
        },
      ],
      [
        "BASES EA-913005999-N26-2023 ESTUDIO DE EFICIENCIA ENERGETICA 52 POZOS (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N26-2023 ESTUDIO DE EFICIENCIA ENERGETICA 52 POZOS (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N27-2023 ADQUISICIÓN DE VARIADORES DE VELOCIDAD (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N27-2023 ADQUISICIÓN DE VARIADORES DE VELOCIDAD (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N28-2023 SERVICIOS DE ACCESO DE INTERNET, REDES Y PROCESAMIENTO DE INFORMACIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N28-2023 SERVICIOS DE ACCESO DE INTERNET, REDES Y PROCESAMIENTO DE INFORMACIÓN.pdf",
        },
      ],
      [
        "BASES EA-913005999-N29-2023 MANTENIMIENTO DE EQUIPO Y APARATOS DE COMUNICACIÓN Y TELECOMUNICACIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N29-2023 MANTENIMIENTO DE EQUIPO Y APARATOS DE COMUNICACIÓN Y TELECOMUNICACIÓN.pdf",
        },
      ],
      [
        "BASES EA-913005999-N30-2023 VESTUARIO Y UNIFORMES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N30-2023 VESTUARIO Y UNIFORMES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N31-2023 BIENES INFORMATICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N31-2023 BIENES INFORMATICOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N32-2023 REFACCIONES Y ACCESORIOS MENORES DE QUIPO DE COMPUTO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N32-2023 REFACCIONES Y ACCESORIOS MENORES DE QUIPO DE COMPUTO.pdf",
        },
      ],
      [
        "BASES EA-913005999-N33-2023 HERRAMIENTAS MENORES (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N33-2023 HERRAMIENTAS MENORES (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N34-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N34-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N35-2023 SERVICIOS INTEGRALES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N35-2023 SERVICIOS INTEGRALES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N36-2023 FLETES Y MANIOBRAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N36-2023 FLETES Y MANIOBRAS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N37-2023 EQUIPO MEDICO Y DE LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N37-2023 EQUIPO MEDICO Y DE LABORATORIO.pdf",
        },
      ],
      [
        "BASES EA-913005999-N38-2023 MATERIAL ELÉCTRICO Y MATERIAL ELECTRÓNICO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N38-2023 MATERIAL ELÉCTRICO Y MATERIAL ELECTRÓNICO.pdf",
        },
      ],
      [
        "BASES EA-913005999-N39-2023 MANTENIMIENTO DE MAQUINARIA Y EQUIPO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N39-2023 MANTENIMIENTO DE MAQUINARIA Y EQUIPO.pdf",
        },
      ],
      [
        "BASES EA-913005999-N40-2023 SERVICIOS DE CONSULTORÍA Y ASESORÍA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N40-2023 SERVICIOS DE CONSULTORÍA Y ASESORÍA.pdf",
        },
      ],
      [
        "BASES EA-913005999-N41-2023 MATERIALES, ACCESORIOS Y SUMINISTROS DE LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N41-2023 MATERIALES, ACCESORIOS Y SUMINISTROS DE LABORATORIO.pdf",
        },
      ],
      [
        "BASES EA-913005999-N42-2023 BIENES INFORMATICOS (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N42-2023 BIENES INFORMATICOS (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N43-2023 REFACCIONES Y ACCESORIOS MENORES DE QUIPO DE COMPUTO (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N43-2023 REFACCIONES Y ACCESORIOS MENORES DE QUIPO DE COMPUTO (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N44-2023 VEHICULOS Y EQUIPO TERRESTRE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N44-2023 VEHICULOS Y EQUIPO TERRESTRE.pdf",
        },
      ],
      [
        "BASES EA-913005999-N45-2023 Instrumental Medico y de Laboratorio Bien",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N45-2023 Instrumental Medico y de Laboratorio Bien.pdf",
        },
      ],
      [
        "BASES EA-913005999-N46-2023 MEDIDORES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N46-2023 MEDIDORES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N47-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N47-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N48-2023 MATERIALES Y UTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFORMÁTICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N48-2023 MATERIALES Y UTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFORMÁTICOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N49-2023 SERVICIOS INTEGRALES BIEN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N49-2023 SERVICIOS INTEGRALES BIEN.pdf",
        },
      ],
      [
        "BASES EA-913005999-N50-2023 VEHICULOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N50-2023 VEHICULOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N51-2023 CAPACITACIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N51-2023 CAPACITACIÓN.pdf",
        },
      ],
      [
        "BASES EA-913005999-N52-2023 ARTICULOS METALICOS PARA LA CONSTRUCCIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N52-2023 ARTICULOS METALICOS PARA LA CONSTRUCCIÓN.pdf",
        },
      ],
      [
        "BASES EA-913005999-N53-2023 Materiales, Accesorios y Suministros Médicos",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N53-2023 Materiales, Accesorios y Suministros Médicos.pdf",
        },
      ],
      [
        "BASES EA-913005999-N54-2023 Materiales, accesorios y suministros de laboratorio 2do procedimiento",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N54-2023 Materiales, accesorios y suministros de laboratorio 2do procedimiento.pdf",
        },
      ],
      [
        "BASES EA-913005999-N55-2023 SERVICIO DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N55-2023 SERVICIO DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIÓN.pdf",
        },
      ],
      [
        "BASES EA-913005999-N56-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N56-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N57-2023 MATERIAL ELÉCTRICO Y MATERIAL ELECTRÓNICO (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N57-2023 MATERIAL ELÉCTRICO Y MATERIAL ELECTRÓNICO (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N58-2023 CAPACITACIÓN (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N58-2023 CAPACITACIÓN (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N59-2023 2do. Instrumental Medico y de Laboratorio Bien",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N59-2023 2do. Instrumental Medico y de Laboratorio Bien.pdf",
        },
      ],
      [
        "BASES EA-913005999-N60-2023 ARRENDAMIENTO DE VEHÍCULOS Y EQUIPO DE TRANSPORTE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N60-2023 ARRENDAMIENTO DE VEHÍCULOS Y EQUIPO DE TRANSPORTE.pdf",
        },
      ],
      [
        "BASES EA-913005999-N61-2023 FIBRAS SINTÉTICAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N61-2023 FIBRAS SINTÉTICAS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N62-2023 INSTALACIÓN, REPARACIÓN Y MANTENIMIENTO DE BIENES INFORMÁTICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N62-2023 INSTALACIÓN, REPARACIÓN Y MANTENIMIENTO DE BIENES INFORMÁTICOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N63-2023 SERVICIOS DE INFORMÁTICA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N63-2023 SERVICIOS DE INFORMÁTICA.pdf",
        },
      ],
      [
        "BASES EA-913005999-N64-2023 SERVICIOS INTEGRALES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N64-2023 SERVICIOS INTEGRALES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N65-2023 ARTICULOS METALICOS PARA LA CONSTRUCCIÓN 2DO PROCEDIMIENTO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N65-2023 ARTICULOS METALICOS PARA LA CONSTRUCCIÓN 2DO PROCEDIMIENTO.pdf",
        },
      ],
      [
        "BASES EA-913005999-N66-2023 EQUIPOS Y APARATOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N66-2023 EQUIPOS Y APARATOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N67-2023 ADQUISICIÓN DE 6 CARROS CISTERNA PARA AGUA POTABLE DE 10 M3 DE CAPACIDAD[1]",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N67-2023 ADQUISICIÓN DE 6 CARROS CISTERNA PARA AGUA POTABLE DE 10 M3 DE CAPACIDAD[1].pdf",
        },
      ],
      [
        "BASES EA-913005999-N68-2023 ADQUISICIÓN DE GRÚA CON PLATAFORMA PARA OPERACIÓN EN POZO CON CAPACIDAD DE CARGA DE 80 TONELADAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N68-2023 ADQUISICIÓN DE GRÚA CON PLATAFORMA PARA OPERACIÓN EN POZO CON CAPACIDAD DE CARGA DE 80 TONELADAS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N69-2023 TELEMETRÍA CONTROL Y COMUNICACIÓN PARA TANQUES Y REBOMBEOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N69-2023 TELEMETRÍA CONTROL Y COMUNICACIÓN PARA TANQUES Y REBOMBEOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N70-2023 EQUIPAMIENTO PARA SU INTEGRACIÓN L SISTEMA DE TELEMTRIA Y CONTROL DE POZOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N70-2023 EQUIPAMIENTO PARA SU INTEGRACIÓN L SISTEMA DE TELEMTRIA Y CONTROL DE POZOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N71-2023 SERVICIO DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIÓN (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N71-2023 SERVICIO DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIÓN (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "BASES EA-913005999-N72-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N72-2023.pdf",
        },
      ],
      [
        "BASES EA-913005999-N73-2023 EQUIPO DE VIGILANCIA ESTACIONES DE BOMBEO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N73-2023 EQUIPO DE VIGILANCIA ESTACIONES DE BOMBEO.pdf",
        },
      ],
      [
        "BASES EA-913005999-N74-2023 ADQUISICIÓN DE GRÚA CON PLATAFORMA PARA OPERACIÓN EN POZO CON CAPACIDAD DE CARGA DE 30 TONELADAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N74-2023 ADQUISICIÓN DE GRÚA CON PLATAFORMA PARA OPERACIÓN EN POZO CON CAPACIDAD DE CARGA DE 30 TONELADAS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N75-2023 REHABILITACIÓN ELÉCTRICA PARA POZOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N75-2023 REHABILITACIÓN ELÉCTRICA PARA POZOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N76-2023 SWITCH DE 48 PUERTOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N76-2023 SWITCH DE 48 PUERTOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N77-2023 EQUIPOS Y APARATOS 2DO. POROCEDIMIENTO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N77-2023 EQUIPOS Y APARATOS 2DO. POROCEDIMIENTO.pdf",
        },
      ],
      [
        "BASES EA-913005999-N78-2023 TRASLADO DE VALORES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N78-2023 TRASLADO DE VALORES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N79-2023 ESTUDIOS E INVESTIGACIONES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N79-2023 ESTUDIOS E INVESTIGACIONES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N80-2023 FLETES Y MANIOBRAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N80-2023 FLETES Y MANIOBRAS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N81-2023 ALIMENTACION",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N81-2023 ALIMENTACION.pdf",
        },
      ],
      [
        "BASES EA-913005999-N82-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N82-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N83-2023 EQUIPAMIENTO PARA ELIMINACION DE BACTERIA EN PLANTA EL BORDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N83-2023 EQUIPAMIENTO PARA ELIMINACION DE BACTERIA EN PLANTA EL BORDO.pdf",
        },
      ],
      [
        "BASES EA-913005999-N84-2023 AMPLIACIÓN DE LA PLANTA DE DE TRATAMIENTO DE AGUAS RESIDUALES SOLARES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N84-2023 AMPLIACIÓN DE LA PLANTA DE DE TRATAMIENTO DE AGUAS RESIDUALES SOLARES.pdf",
        },
      ],
      [
        "BASES EA-913005999-N85-2023 SERVICIOS INTEGRALES DE CONTROL VEHICULAR",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N85-2023 SERVICIOS INTEGRALES DE CONTROL VEHICULAR.pdf",
        },
      ],
      [
        "BASES EA-913005999-N86-2023 ARRENDAMIENTO DE VEHÍCULOS Y EQUIPO DE TRANSPORTE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N86-2023 ARRENDAMIENTO DE VEHÍCULOS Y EQUIPO DE TRANSPORTE.pdf",
        },
      ],
      [
        "BASES EA-913005999-N87-2023 SISTEMA DE CONTROL ADMINISTRATIVO Y OPERATIVO DE AGUA CAASIM",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N87-2023 SISTEMA DE CONTROL ADMINISTRATIVO Y OPERATIVO DE AGUA CAASIM.pdf",
        },
      ],
      [
        "BASES EA-913005999-N88-2023 ARRENDAMIENTO DE EQUIPO Y BIENES INFORMÁTICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N88-2023 ARRENDAMIENTO DE EQUIPO Y BIENES INFORMÁTICOS.pdf",
        },
      ],
      [
        "BASES EA-913005999-N89-2023 SUSTANCIAS QUÍMICAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/BASES EA-913005999-N89-2023 SUSTANCIAS QUÍMICAS.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-01-2023 ZONA I",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-01-2023 ZONA I.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-02-2023 ZONA II",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-02-2023 ZONA II.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-03-2023 ZONA III",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-03-2023 ZONA III.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-04-2023 ZONA IV",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-04-2023 ZONA IV.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-05-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-05-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-06-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-06-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-07-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-07-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-08-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-08-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-09-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-09-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-10-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-10-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-11-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-11-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-12-2023 ZONA I",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-12-2023 ZONA I.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-13-2023 ZONA II",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-13-2023 ZONA II.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-14-2023 ZONA III",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-14-2023 ZONA III.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-15-2023 ZONA IV",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-15-2023 ZONA IV.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-16-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-16-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-17-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-17-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-18-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-18-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-19-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-19-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-20-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-20-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-21-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-21-2023.pdf",
        },
      ],
      [
        "CATALOGO CAASIM LOP-22-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO CAASIM LOP-22-2023.pdf",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-23-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO MUDO CAASIM-HGO-L.O.P.-23-2023.pdf",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-24-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO MUDO CAASIM-HGO-L.O.P.-24-2023.pdf",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-25-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO MUDO CAASIM-HGO-L.O.P.-25-2023.pdf",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-26-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CATALOGO MUDO CAASIM-HGO-L.O.P.-26-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 01-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 01-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 02-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 02-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 03-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 03-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 04-2023 OBRA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 04-2023 OBRA.pdf",
        },
      ],
      [
        "CONVOCATORIA 05-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 05-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 06-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 06-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 07-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 07-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 08-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 08-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 09-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 09-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 10-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 10-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 13-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 13-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 14",
        { text: ".pdf", link: "/CAASIM/licitaciones/2023/CONVOCATORIA 14.pdf" },
      ],
      [
        "CONVOCATORIA 15-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 15-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 16-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 16-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 17-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 17-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 18-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 18-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 19-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 19-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 20-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 20-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 21-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 21-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 22-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 22-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA 23-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA 23-2023.pdf",
        },
      ],
      [
        "CONVOCATORIA NO. 1 OBRA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA NO. 1 OBRA.pdf",
        },
      ],
      [
        "CONVOCATORIA NO. 2 OBRA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA NO. 2 OBRA.pdf",
        },
      ],
      [
        "CONVOCATORIA NO. 3 OBRA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA NO. 3 OBRA.pdf",
        },
      ],
      [
        "CONVOCATORIA VESTUARIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CONVOCATORIA VESTUARIO.pdf",
        },
      ],
      [
        "CROQUIS DE LOCALIZACIÓN  CAASIM-HGO-L.O.P.-25-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CROQUIS DE LOCALIZACIÓN  CAASIM-HGO-L.O.P.-25-2023.pdf",
        },
      ],
      [
        "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-23-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-23-2023.pdf",
        },
      ],
      [
        "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-24-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-24-2023.pdf",
        },
      ],
      [
        "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-26-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-26-2023.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P-15-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO CAASIM-HGO-L.O.P-15-2023.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P-17-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO CAASIM-HGO-L.O.P-17-2023.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P-19-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO CAASIM-HGO-L.O.P-19-2023.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P-21-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO CAASIM-HGO-L.O.P-21-2023.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-06-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO CAASIM-HGO-L.O.P.-06-2023.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-07-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO CAASIM-HGO-L.O.P.-07-2023.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-23-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO CAASIM-HGO-L.O.P.-23-2023.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-24-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO CAASIM-HGO-L.O.P.-24-2023.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-25-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO CAASIM-HGO-L.O.P.-25-2023.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-26-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO CAASIM-HGO-L.O.P.-26-2023.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N3-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO DIFERIDO EA-913005999-N3-2023.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N4-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO DIFERIDO EA-913005999-N4-2023.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N5-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO DIFERIDO EA-913005999-N5-2023.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N16-2023 MOBILIARIO, ESTANTERÍA Y EQUIPO DE ADMINISTRACIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO DIFERIDO EA-913005999-N16-2023 MOBILIARIO, ESTANTERÍA Y EQUIPO DE ADMINISTRACIÓN.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N23-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO DIFERIDO EA-913005999-N23-2023.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N34-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO DIFERIDO EA-913005999-N34-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N38-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO DIFERIDO EA-913005999-N38-2023.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N56-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO DIFERIDO EA-913005999-N56-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "FALLO EA-91335999-N61-2023 FIBRAS SINTETICAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-91335999-N61-2023 FIBRAS SINTETICAS.pdf",
        },
      ],
      [
        "FALLO EA-93005999-N35-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-93005999-N35-2023.pdf",
        },
      ],
      [
        "FALLO EA-93005999-N36-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-93005999-N36-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N1-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N1-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N2-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N2-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N3-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N3-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N3-2023 DIFERIDO 2",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N3-2023 DIFERIDO 2.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N4-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N4-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N4-2023 DIFERIDO 2",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N4-2023 DIFERIDO 2.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N5-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N5-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N6-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N6-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N7-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N7-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N8-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N8-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N9-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N9-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N9-2023 PRODUCTOS MINERALES NO METALICOS (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N9-2023 PRODUCTOS MINERALES NO METALICOS (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "FALLO EA-913005999-N10-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N10-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N11-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N11-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N14-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N14-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N15-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N15-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N16-2023 MOBILIARIO, ESTANTERÍA Y EQUIPO DE ADMINISTRACIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N16-2023 MOBILIARIO, ESTANTERÍA Y EQUIPO DE ADMINISTRACIÓN.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N17-2023 EQUIPOS DE GENERACIÓN ELÉCTRICA, APARATOS Y ACCESORIOS ELÉCTRICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N17-2023 EQUIPOS DE GENERACIÓN ELÉCTRICA, APARATOS Y ACCESORIOS ELÉCTRICOS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N18-2023 REFACCIONES Y ACCESORIOS MENORES DE MAQUINARIA Y OTROS EQUIPOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N18-2023 REFACCIONES Y ACCESORIOS MENORES DE MAQUINARIA Y OTROS EQUIPOS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N19-2023 REPOSICION DE PAVIMENTO DE CONCRETO ASFALTICO EN EL MUNICIPIO DE PACHUCA DE SOTO, MINERAL DE LA REFORMA Y SU ZONA DE INLFUENCIA  DE LA CAASIM",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N19-2023 REPOSICION DE PAVIMENTO DE CONCRETO ASFALTICO EN EL MUNICIPIO DE PACHUCA DE SOTO, MINERAL DE LA REFORMA Y SU ZONA DE INLFUENCIA  DE LA CAASIM.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N20-2023 ADQUISICION DE VARIADORES DE VELOCIDAD PARA SU INTEGRACION AL SISTEMA DE TELEMETRIA Y CONTROL",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N20-2023 ADQUISICION DE VARIADORES DE VELOCIDAD PARA SU INTEGRACION AL SISTEMA DE TELEMETRIA Y CONTROL.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N20-2023 ADQUISICIÓN DE VARIADORES DE VELOCIDAD PARA SU INTEGRACION AL SISTEMA DE TELEMETRÍA Y CONTROL",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N20-2023 ADQUISICIÓN DE VARIADORES DE VELOCIDAD PARA SU INTEGRACION AL SISTEMA DE TELEMETRÍA Y CONTROL.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N21-2023 ADQUISICION DE EQUIPOS DE BOMBEO PARA POZOS Y ´PLANTAS DE BOMBEO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N21-2023 ADQUISICION DE EQUIPOS DE BOMBEO PARA POZOS Y ´PLANTAS DE BOMBEO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N22-2023 ESTUDIO DE EFICIENCIA ENERGETICA ELECTROMECANICA Y BALANCE HIDRAULICO A DE 52 POZOS DE EXTRCCION DE AGUA POTABLE EN CAASIM",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N22-2023 ESTUDIO DE EFICIENCIA ENERGETICA ELECTROMECANICA Y BALANCE HIDRAULICO A DE 52 POZOS DE EXTRCCION DE AGUA POTABLE EN CAASIM.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N23-2023 HERRAMIENTA MENOR",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N23-2023 HERRAMIENTA MENOR.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N24-2023 OTROS MATERIALES Y ARTÍCULOS DE CONSTRUCCIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N24-2023 OTROS MATERIALES Y ARTÍCULOS DE CONSTRUCCIÓN.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N24-2023 OTROS MATERIALES Y ARTÍCULOS DE CONSTRUCCIÓN Y REPARACIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N24-2023 OTROS MATERIALES Y ARTÍCULOS DE CONSTRUCCIÓN Y REPARACIÓN.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N25-2023 MAQUINARIA Y EQUIPO INDUSTRIAL",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N25-2023 MAQUINARIA Y EQUIPO INDUSTRIAL.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N28-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N28-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N29-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N29-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N30-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N30-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N31-2023 BIENES INFORMÁTICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N31-2023 BIENES INFORMÁTICOS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N32-2023 REFACCIONES Y ACCESORIOS MENORES DE EQUIPO DE COMPUTO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N32-2023 REFACCIONES Y ACCESORIOS MENORES DE EQUIPO DE COMPUTO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N33-2023 HERRAMIENTA MENOR (SEGUNDO PROCEDIMI",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N33-2023 HERRAMIENTA MENOR (SEGUNDO PROCEDIMI.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N33-2023 HERRAMIENTAS MENORES (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N33-2023 HERRAMIENTAS MENORES (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "FALLO EA-913005999-N34-2023 OTROS EQUIPOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N34-2023 OTROS EQUIPOS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N37-2023 EQUIPO MEDICO Y DE LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N37-2023 EQUIPO MEDICO Y DE LABORATORIO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N38-2023 MATERIAL ELECTRICO Y ELECTRONICO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N38-2023 MATERIAL ELECTRICO Y ELECTRONICO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N39-2023 MANTENIMIENTO DE MAQUINARIA Y EQUIPO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N39-2023 MANTENIMIENTO DE MAQUINARIA Y EQUIPO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N40-2023 SERVICIOS DE CONSULTORÍA Y ASESORÍA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N40-2023 SERVICIOS DE CONSULTORÍA Y ASESORÍA.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N41-2023 MATERIALES, ACCESORIOS Y SUMINISTROS DE LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N41-2023 MATERIALES, ACCESORIOS Y SUMINISTROS DE LABORATORIO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N42-2023 BIENES INFORMÁTICOS (SEGUNDO P)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N42-2023 BIENES INFORMÁTICOS (SEGUNDO P).pdf",
        },
      ],
      [
        "FALLO EA-913005999-N43-2023 REFACCIONES DE COMPUTO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N43-2023 REFACCIONES DE COMPUTO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N44-2023 VEHICULOS Y EQUIPO  TERRESTRE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N44-2023 VEHICULOS Y EQUIPO  TERRESTRE.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N45-2023 INSTRUMENTAL MÉDICO Y DE LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N45-2023 INSTRUMENTAL MÉDICO Y DE LABORATORIO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N46-2023 MERCANCIAS ADQUIRIDAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N46-2023 MERCANCIAS ADQUIRIDAS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N47-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N47-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N48-2023 MATERIALES Y ÚTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFORMÁTICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N48-2023 MATERIALES Y ÚTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFORMÁTICOS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N49-2023 SERVICIOS INTEGRALES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N49-2023 SERVICIOS INTEGRALES.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N50-2023 VEHICULOS Y EQUIPO TERRESTRE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N50-2023 VEHICULOS Y EQUIPO TERRESTRE.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N51-2023 CAPACITACIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N51-2023 CAPACITACIÓN.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N52-2023 ARTICULOS METÁLICOS PARA LA CONSTRUCCIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N52-2023 ARTICULOS METÁLICOS PARA LA CONSTRUCCIÓN.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N53-2023 MATERIAL, ACCESORIOS Y SUMINISTROS MÉDICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N53-2023 MATERIAL, ACCESORIOS Y SUMINISTROS MÉDICOS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N55-2023 SERVICIOS DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESION",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N55-2023 SERVICIOS DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESION.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N56-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N56-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "FALLO EA-913005999-N57-2023 MATERIAL ELECTRICO Y ELECTRONICO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N57-2023 MATERIAL ELECTRICO Y ELECTRONICO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N58-2023 CAPACITACIÓN (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N58-2023 CAPACITACIÓN (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "FALLO EA-913005999-N59-2023INSTRUIMENTAL MÉDICO Y DE LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N59-2023INSTRUIMENTAL MÉDICO Y DE LABORATORIO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N60-2023 ARRENDAMIENTO DE VEHICULOS Y EQUIPO TERRESTRE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N60-2023 ARRENDAMIENTO DE VEHICULOS Y EQUIPO TERRESTRE.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N62-2023 INSTALACION, REPARACION Y MANTENIMIENTO DE BIENES INFORMATICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N62-2023 INSTALACION, REPARACION Y MANTENIMIENTO DE BIENES INFORMATICOS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N63-2023 SERVICIOS DE INFORMATICA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N63-2023 SERVICIOS DE INFORMATICA.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N64-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N64-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N65-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N65-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N66-2023 EQUIPOS Y APARATOS DE COMUNICACION Y TELECOMUNICACION",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N66-2023 EQUIPOS Y APARATOS DE COMUNICACION Y TELECOMUNICACION.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N67-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N67-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N68-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N68-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N69-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N69-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N70-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N70-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N71-2023 SERVICIOS DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIÓN (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N71-2023 SERVICIOS DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIÓN (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "FALLO EA-913005999-N72-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N72-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N73-2023 PROYECTO DE VIDEO VIGILANCIA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N73-2023 PROYECTO DE VIDEO VIGILANCIA.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N74-2023 ADQUISICIÓN DE GRÚA CON PLATAFORMA PARA OPERACIÓN EN POZO CON CAPACIDAD DE CARGA DE 30 TONELADAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N74-2023 ADQUISICIÓN DE GRÚA CON PLATAFORMA PARA OPERACIÓN EN POZO CON CAPACIDAD DE CARGA DE 30 TONELADAS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N75-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N75-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N76-2023 SWITCH DE 48 PUERTOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N76-2023 SWITCH DE 48 PUERTOS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N77-2023 EQUIPOS Y APARATOS DE COMUNICACION",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N77-2023 EQUIPOS Y APARATOS DE COMUNICACION.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N78-2023 TRASLADO DE VALORES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N78-2023 TRASLADO DE VALORES.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N79-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N79-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N80-2023 FLETES Y MANIOBRAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N80-2023 FLETES Y MANIOBRAS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N82-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N82-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N83-2023 EQUIPAMENTO PARA ELIMINACIÓN DE BACTERIA EN LA PLANTA DEL BORDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N83-2023 EQUIPAMENTO PARA ELIMINACIÓN DE BACTERIA EN LA PLANTA DEL BORDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N84-2023 AMPLIACIÓN DE LA PLANTA DE TRATAMIENTO DE AGUAS RESIDUALES SOLARES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N84-2023 AMPLIACIÓN DE LA PLANTA DE TRATAMIENTO DE AGUAS RESIDUALES SOLARES.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N85-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N85-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N86-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N86-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N87-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N87-2023.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N88-2023 ARRENDAMIENTO DE EQUIPO Y BIENES INFORMÁTICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N88-2023 ARRENDAMIENTO DE EQUIPO Y BIENES INFORMÁTICOS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N89-2023 SUSTANCIAS QUÍMICAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/FALLO EA-913005999-N89-2023 SUSTANCIAS QUÍMICAS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-12-2023 ZONA 1",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-12-2023 ZONA 1.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-13-2023 ZONA 2",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-13-2023 ZONA 2.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-14-2023 ZONA 3",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-14-2023 ZONA 3.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-15-2023 ZONA 4",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-15-2023 ZONA 4.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-16-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-16-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-17-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-17-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-18-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-18-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-19-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-19-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-20-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-20-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-21-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-21-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-22-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-22-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-05-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-05-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-23-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-23-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-24-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-24-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-25-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-25-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-06-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-06-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-07-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-07-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-08-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-08-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-09-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-09-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-10-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-10-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-11-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-11-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM.HGO-L.O.P.-26-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES CAASIM.HGO-L.O.P.-26-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N1-2023 SERVICIO DE TRASLADO DE VALORES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N1-2023 SERVICIO DE TRASLADO DE VALORES.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N2-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N2-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N3-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N3-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N4-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N4-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N5-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N5-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N6-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N6-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N7-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N7-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N8-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N8-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N9-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N9-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N10-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N10-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N11-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N11-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N14-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N14-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N15-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N15-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N16-2023 MUEBLES DE OFICINA, ESTANTERIA Y EQUIPO DE ADMINISTRACIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N16-2023 MUEBLES DE OFICINA, ESTANTERIA Y EQUIPO DE ADMINISTRACIÓN.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N17-2023 EQUIPOS DE GENERACIÓN ELÉCTRICA, APARATOS Y ACCESORIOS ELÉCTRICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N17-2023 EQUIPOS DE GENERACIÓN ELÉCTRICA, APARATOS Y ACCESORIOS ELÉCTRICOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N18-2023 REFACCIONES Y ACCESORIOS MENORES DE MAQUINARIA Y OTROS EQUIPOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N18-2023 REFACCIONES Y ACCESORIOS MENORES DE MAQUINARIA Y OTROS EQUIPOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N19-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N19-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N20-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N20-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N21-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N21-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N22-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N22-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N23-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N23-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N24-2023 OTROS MATERIALES Y ARTICULOS DE CONSTRUCCION Y REPARACION",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N24-2023 OTROS MATERIALES Y ARTICULOS DE CONSTRUCCION Y REPARACION.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N25-2023 MAQUINARIA Y EQUIPO INDUSTRIAL",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N25-2023 MAQUINARIA Y EQUIPO INDUSTRIAL.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N26-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N26-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N27-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N27-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N28-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N28-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N29-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N29-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N30-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N30-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N31-2023 BIENES INFORMATICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N31-2023 BIENES INFORMATICOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N32-2023 REFACCIONES Y ACCESORIOS MENORES DE EQUIPO DE COMPUTO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N32-2023 REFACCIONES Y ACCESORIOS MENORES DE EQUIPO DE COMPUTO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N33-2023 HERRAMIENTA MENOR",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N33-2023 HERRAMIENTA MENOR.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N34-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N34-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N35-2023 SERVICIOS INTEGRALES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N35-2023 SERVICIOS INTEGRALES.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N36-2023 FLETES Y MANIOBRAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N36-2023 FLETES Y MANIOBRAS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N37-2023 EQUIPO MEDICO Y DE LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N37-2023 EQUIPO MEDICO Y DE LABORATORIO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N38-2023 MATERIAL ELECTRICO Y MATERIAL ELECTRONICO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N38-2023 MATERIAL ELECTRICO Y MATERIAL ELECTRONICO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N39-2023 MANTENIMIENTO DE MAQUINARIA Y EQUIPO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N39-2023 MANTENIMIENTO DE MAQUINARIA Y EQUIPO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N40-2023 SERVICIOS DE CONSULTORÍA Y ASESORÍA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N40-2023 SERVICIOS DE CONSULTORÍA Y ASESORÍA.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N41-2023 MATERIALES Y SUMINISTROS DE LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N41-2023 MATERIALES Y SUMINISTROS DE LABORATORIO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N42-2023 BIENES INFORMATICOS (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N42-2023 BIENES INFORMATICOS (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N43-2023 REFACCIONES Y ACCESORIOS MENORES DE EQUIPO DE COMPUTO Y TECNOLOGIAS DE L AINFORMACIÓN (SEGUNDO PROCE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N43-2023 REFACCIONES Y ACCESORIOS MENORES DE EQUIPO DE COMPUTO Y TECNOLOGIAS DE L AINFORMACIÓN (SEGUNDO PROCE.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N44-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N44-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N45-2023 INSTRUMENTAL MÉDICO Y DE LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N45-2023 INSTRUMENTAL MÉDICO Y DE LABORATORIO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N46-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N46-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N47-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N47-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N48-2023 MATERIALES Y ÚTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFROMÁTICOS",
        {
          text: ".PDF",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N48-2023 MATERIALES Y ÚTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFROMÁTICOS.PDF",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N49-2023SERVICIOS INTEGRALES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N49-2023SERVICIOS INTEGRALES.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N50-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N50-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N51-2023 CAPACITACIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N51-2023 CAPACITACIÓN.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N52-2023 ARTÍCULOS METÁLICOS PARA LA CONSTRUCCIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N52-2023 ARTÍCULOS METÁLICOS PARA LA CONSTRUCCIÓN.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N53-2023 MATERIIALES, ACCESORIOS Y SUMINISTROS MÉDICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N53-2023 MATERIIALES, ACCESORIOS Y SUMINISTROS MÉDICOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N54-2023 MATERIALES, ACCESORIOS Y SUMINISTROS DE LABORATORIO 2DO PROCEDIMIENTO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N54-2023 MATERIALES, ACCESORIOS Y SUMINISTROS DE LABORATORIO 2DO PROCEDIMIENTO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N55-2023 SERVICIOS DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N55-2023 SERVICIOS DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIÓN.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N56-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N56-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N57-2023 MATERIAL ELECTRICO Y MATERIAL ELECTRONICO (2DO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N57-2023 MATERIAL ELECTRICO Y MATERIAL ELECTRONICO (2DO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N58-2023 CAPACITACIÓN (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N58-2023 CAPACITACIÓN (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N59-2023INSTRUMENTAL MÉDICO Y DE  LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N59-2023INSTRUMENTAL MÉDICO Y DE  LABORATORIO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N60-2023 ARRENDAMIENTO DE VEHÍCULOS Y EQUIPO DE TRANSPORTE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N60-2023 ARRENDAMIENTO DE VEHÍCULOS Y EQUIPO DE TRANSPORTE.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N61-2023 FIBRAS SINTETICAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N61-2023 FIBRAS SINTETICAS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N62-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N62-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N63-2023",
        {
          text: ".PDF",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N63-2023.PDF",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N64-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N64-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N65-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N65-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N66-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N66-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N67-2023 ADQUISICION DE 6 CARROS CISTERNA PARA AGUA POTABLE DE 10 M3 DE CAPACIDAD",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N67-2023 ADQUISICION DE 6 CARROS CISTERNA PARA AGUA POTABLE DE 10 M3 DE CAPACIDAD.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N68-2023 ADQUISICION DE GRUA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N68-2023 ADQUISICION DE GRUA.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N69-2023 TELEMETRIA Y COMUNICACION PARA TANQUES Y REBOMBEOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N69-2023 TELEMETRIA Y COMUNICACION PARA TANQUES Y REBOMBEOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N70-2023 EQUIPAMIENTO PARA SU INTEGRACIÓN AL SISTEMA DE TELETRIA Y CONTROL DE POZOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N70-2023 EQUIPAMIENTO PARA SU INTEGRACIÓN AL SISTEMA DE TELETRIA Y CONTROL DE POZOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N71-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N71-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N72-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N72-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N73-2023 PROYECTO DE VIDEO VIGILANCIA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N73-2023 PROYECTO DE VIDEO VIGILANCIA.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N74-2023 ADQUISICION DE GRUA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N74-2023 ADQUISICION DE GRUA.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N75-2023 REHABILITACION ELÉCTRICA PARA POZOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N75-2023 REHABILITACION ELÉCTRICA PARA POZOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N76-2023 SWITCH DE 48 PUERTOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N76-2023 SWITCH DE 48 PUERTOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N77-2023 EQUIPOS Y APARATOS DE COMUNICACION Y TELECOMUNICACION SEGUNDO PROCEDIMIENTO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N77-2023 EQUIPOS Y APARATOS DE COMUNICACION Y TELECOMUNICACION SEGUNDO PROCEDIMIENTO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N78-2023 SERVICIO DE TRASLADO DE VALORES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N78-2023 SERVICIO DE TRASLADO DE VALORES.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N79-2023 ESTUDIOS E INVESTIGACIONES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N79-2023 ESTUDIOS E INVESTIGACIONES.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N80-2023 FLETES Y MANIOBRAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N80-2023 FLETES Y MANIOBRAS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N81-2023 ALIMENTACION DE PERSONAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N81-2023 ALIMENTACION DE PERSONAS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N82-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N82-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N83-2023 EQUIPAMIENTO PARA ELIMINACION DE BACTERIA EN PLANTA EL BORDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N83-2023 EQUIPAMIENTO PARA ELIMINACION DE BACTERIA EN PLANTA EL BORDO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N84-2023 AMPLIACION DE LA PLANTA DE TRATAMIENTO DE AGUAS RESIDUALES SOLARES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N84-2023 AMPLIACION DE LA PLANTA DE TRATAMIENTO DE AGUAS RESIDUALES SOLARES.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N85-2023 SERVICIOS INTEGRALES DE CONTROL VEHICULAR",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N85-2023 SERVICIOS INTEGRALES DE CONTROL VEHICULAR.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N86-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N86-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N87-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N87-2023.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N88-2023 ARRENDAMIENTO DE EQUIPO Y BIENES INFORMÁTICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N88-2023 ARRENDAMIENTO DE EQUIPO Y BIENES INFORMÁTICOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N89-2023 SSTANCIAS QUÍMICAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/JUNTA DE ACLARACIONES EA-913005999-N89-2023 SSTANCIAS QUÍMICAS.pdf",
        },
      ],
      [
        "MAPA BACHEO ZONA I, II, III, IV",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/MAPA BACHEO ZONA I, II, III, IV.pdf",
        },
      ],
      [
        "MAPA BACHEO ZONA I, II, III, IV (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/MAPA BACHEO ZONA I, II, III, IV (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N26-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N26-2023.pdf",
        },
      ],
      [
        "PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N27-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N27-2023.pdf",
        },
      ],
      [
        "PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N28-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N28-2023.pdf",
        },
      ],
      [
        "PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N29-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N29-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES CAASIM-HGO-L.O.P.23-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES CAASIM-HGO-L.O.P.23-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES CAASIM-HGO-L.O.P.24-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES CAASIM-HGO-L.O.P.24-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES CAASIM-HGO-L.O.P.25-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES CAASIM-HGO-L.O.P.25-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES CAASIM-HGO-L.O.P.-26-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES CAASIM-HGO-L.O.P.-26-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N16-2023 MUEBLES DE OFICINA, ESTANTERÍA Y EQUIPO DE ADMINISTRACIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N16-2023 MUEBLES DE OFICINA, ESTANTERÍA Y EQUIPO DE ADMINISTRACIÓN.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N17-2023 EQUIPOS DE GENERACIÓN ELÉCTRICA, APARATOS Y ACCESORIOS ELÉCTRICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N17-2023 EQUIPOS DE GENERACIÓN ELÉCTRICA, APARATOS Y ACCESORIOS ELÉCTRICOS.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N18-2023 REFACCIONES Y ACCESORIOS MENORES DE MÁQUINARIA Y OTROS EQUIPOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N18-2023 REFACCIONES Y ACCESORIOS MENORES DE MÁQUINARIA Y OTROS EQUIPOS.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N19-2023 REPÓSICION DE PAVIMENTO DE CONCRETO ASFALTICO EN EL MUNICIPIO DE PACHUCA DE SOTO, MINERAL DE LA REFORMA Y SU ZONA DE INLFUENCIA DE LA CAASIM.",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N19-2023 REPÓSICION DE PAVIMENTO DE CONCRETO ASFALTICO EN EL MUNICIPIO DE PACHUCA DE SOTO, MINERAL DE LA REFORMA Y SU ZONA DE INLFUENCIA DE LA CAASIM..pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N20-2023 ADQUISICION DE VARIADORES DE VELOCIDAD PARA SU INTEGRACION AL SISTEMA DE TELEMETRIA Y CONTROL",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N20-2023 ADQUISICION DE VARIADORES DE VELOCIDAD PARA SU INTEGRACION AL SISTEMA DE TELEMETRIA Y CONTROL.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N21-2023 ADQUISICION DE EQUIPOS DE BOMBEO PARA POZOS Y PLANTAS DE BOMBEO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N21-2023 ADQUISICION DE EQUIPOS DE BOMBEO PARA POZOS Y PLANTAS DE BOMBEO.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N23-2023 HERRAMIENTAS MENORES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N23-2023 HERRAMIENTAS MENORES.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N24-2023 OTROS MATERIALES Y ARTICULOS DE CONSTRUCCION Y REPARACION",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N24-2023 OTROS MATERIALES Y ARTICULOS DE CONSTRUCCION Y REPARACION.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N25-2023 MAQUINARIA Y EQUIPO INDUSTRIAL",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOCISIONES EA-913005999-N25-2023 MAQUINARIA Y EQUIPO INDUSTRIAL.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N31-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N31-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N32-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N32-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N33-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N33-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N34-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N34-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N44-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N44-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N45-2023 INSTRUMENTAL MÉDICO Y DE LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N45-2023 INSTRUMENTAL MÉDICO Y DE LABORATORIO.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N46-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N46-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N47-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N47-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N48-2023 MATERIALES Y UTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFORMA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N48-2023 MATERIALES Y UTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFORMA.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N49-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N49-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N50-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N50-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N51-2023 CAPACITACIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N51-2023 CAPACITACIÓN.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N52-2023 ARTÍCULOS METÁLICOS PARA LA CONSTRUCCIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N52-2023 ARTÍCULOS METÁLICOS PARA LA CONSTRUCCIÓN.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N53-2023 MATERIALES, ACCESORIOS Y SUMINISTROS MÉDICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N53-2023 MATERIALES, ACCESORIOS Y SUMINISTROS MÉDICOS.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N54-2023 MATERIALES, ACCESORIOS Y SUMINISTROS DE LABORATORIO (Segundo procedimiento)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N54-2023 MATERIALES, ACCESORIOS Y SUMINISTROS DE LABORATORIO (Segundo procedimiento).pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N55-2023 SERVICIOS DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIÓN",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N55-2023 SERVICIOS DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIÓN.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N56-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS (2DO PROCED",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N56-2023 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES Y OTROS EQUIPOS (2DO PROCED.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N57-2023 MATERIAL ELECTRICO Y MATERIAL ELECTRONICO (2DO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N57-2023 MATERIAL ELECTRICO Y MATERIAL ELECTRONICO (2DO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N58-2023 CAPACITACIÓN (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N58-2023 CAPACITACIÓN (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N59-2023 INSTRUMENTAL MÉDICO Y DE LABORATORIO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N59-2023 INSTRUMENTAL MÉDICO Y DE LABORATORIO.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N60-2023 ARRENDAMIENTO DE VEHÍCULOS Y EQUIPO DE TRANSPORTE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N60-2023 ARRENDAMIENTO DE VEHÍCULOS Y EQUIPO DE TRANSPORTE.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N62-2023 INSTALACION, REPARACION Y MANTENIMIENTO DE BIENES INFORMÁTICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N62-2023 INSTALACION, REPARACION Y MANTENIMIENTO DE BIENES INFORMÁTICOS.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N63-2023 SERVICIOS DE INFORMATICA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N63-2023 SERVICIOS DE INFORMATICA.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N64-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N64-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N65-2023 ARTICULOS METALICOS PARA LA CONSTRUCCIÓN (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N65-2023 ARTICULOS METALICOS PARA LA CONSTRUCCIÓN (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N68-2023 ADQUISICION DE GRU CON PLATAFORMA PARA OPERACION EN POZO CON CAPACIDAD DE CARGA ",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N68-2023 ADQUISICION DE GRU CON PLATAFORMA PARA OPERACION EN POZO CON CAPACIDAD DE CARGA .pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N75-2023",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N75-2023.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N77 EQUIPOS Y APARATOS DE COMUNICACION Y TELECOMUNICACION (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N77 EQUIPOS Y APARATOS DE COMUNICACION Y TELECOMUNICACION (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N78 SERVICIO DE TRASLADO DE VALORES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N78 SERVICIO DE TRASLADO DE VALORES.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N80 FLETES Y MANIOBRAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N80 FLETES Y MANIOBRAS.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N82-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N82-2023 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N83-2023 EQUIPAMIENTO PARA ELIMINACIÓN DE BACTERIA EN PLANTA EL BORDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N83-2023 EQUIPAMIENTO PARA ELIMINACIÓN DE BACTERIA EN PLANTA EL BORDO.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N84-2023 AMPLIACIÓN DE LA PLANTA DE TRATAMIENTO DE AGUAS RESIDUALES SOLARES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N84-2023 AMPLIACIÓN DE LA PLANTA DE TRATAMIENTO DE AGUAS RESIDUALES SOLARES.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N85-2023 SERVICIOS INTEGRALES DE CONTROL VEHICULAR",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N85-2023 SERVICIOS INTEGRALES DE CONTROL VEHICULAR.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N86-2023 ARRENDAMIENTO DE VEHÍCULOS YEQUIPO DE TRANSPORTE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N86-2023 ARRENDAMIENTO DE VEHÍCULOS YEQUIPO DE TRANSPORTE.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N88-2023 ARRENDAMIENTO DE EQUIPO Y BIENES INFORMÁTICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N88-2023 ARRENDAMIENTO DE EQUIPO Y BIENES INFORMÁTICOS.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N89-2023 SUSTANCIAS QUÍMICAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2023/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N89-2023 SUSTANCIAS QUÍMICAS.pdf",
        },
      ],
    ],
  },
  // SECTION 2022
  {
    anio: "2022",
    icono: "fa fa-file-text-o fa-2x",
    formatos: [
      [
        "ACTA DE APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N27-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/ACTA DE APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N27-2022.pdf",
        },
      ],
      [
        "ACTA DE APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N28-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/ACTA DE APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N28-2022.pdf",
        },
      ],
      [
        "ACTA DE FALLO EA-913005999-N37-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/ACTA DE FALLO EA-913005999-N37-2022.pdf",
        },
      ],
      [
        "ACTA DE PRESENTACIÓN Y APERTUR DE PROPOSICIONES EA-913005999-N42-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/ACTA DE PRESENTACIÓN Y APERTUR DE PROPOSICIONES EA-913005999-N42-2022.pdf",
        },
      ],
      [
        "APERTURA CAASIM-HGO-L.O.P.-01-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA CAASIM-HGO-L.O.P.-01-2022.pdf",
        },
      ],
      [
        "APERTURA CAASIM-HGO-L.O.P.-02-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA CAASIM-HGO-L.O.P.-02-2022.pdf",
        },
      ],
      [
        "APERTURA CAASIM-HGO-L.O.P.-03-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA CAASIM-HGO-L.O.P.-03-2022.pdf",
        },
      ],
      [
        "APERTURA CAASIM-HGO-L.O.P.-04-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA CAASIM-HGO-L.O.P.-04-2022.pdf",
        },
      ],
      [
        "APERTURA CAASIM-HGO-L.O.P.-05-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA CAASIM-HGO-L.O.P.-05-2022.pdf",
        },
      ],
      [
        "APERTURA CAASIM-HGO-L.O.P.-06-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA CAASIM-HGO-L.O.P.-06-2022.pdf",
        },
      ],
      [
        "APERTURA CAASIM-HGO-L.O.P.-07-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA CAASIM-HGO-L.O.P.-07-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N15-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N15-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N16-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N16-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N17-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N17-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N35-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N35-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N36-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N36-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N37-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N37-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N38-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N38-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N39-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N39-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N40-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N40-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N41-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N41-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N42-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N42-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N43-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N43-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N44-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N44-2022.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N45-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA EA-913005999-N45-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N10-222",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N10-222.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N11-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N11-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N12-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N12-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N13-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N13-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N14-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N14-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N25-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N25-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N26-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N26-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N30-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N30-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N31-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N31-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N32-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N32-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N33-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N33-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N34-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N34-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N6-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N6-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N7-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N7-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N8-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N8-2022.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N9-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TECNICA Y ECONOMICA EA-913005999-N9-2022.pdf",
        },
      ],
      [
        "APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N29-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/APERTURA TÉCNICA Y ECONÓMICA EA-913005999-N29-2022.pdf",
        },
      ],
      [
        "Aclaraciones E4-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/Aclaraciones E4-2022.pdf",
        },
      ],
      [
        "Aclaraciones LA-913005999-E2-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/Aclaraciones LA-913005999-E2-2022.pdf",
        },
      ],
      [
        "Aclaraciones LA-913005999-E3-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/Aclaraciones LA-913005999-E3-2022.pdf",
        },
      ],
      [
        "Acta de Presentación y Apertura No. EA-913005999-N20-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/Acta de Presentación y Apertura No. EA-913005999-N20-2021.pdf",
        },
      ],
      [
        "Acta de Presentación y Apertura No. EA-913005999-N21-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/Acta de Presentación y Apertura No. EA-913005999-N21-2021.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-01-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/BASES CAASIM-HGO-L.O.P.-01-2022.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-02-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/BASES CAASIM-HGO-L.O.P.-02-2022.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-03-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/BASES CAASIM-HGO-L.O.P.-03-2022.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-04-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/BASES CAASIM-HGO-L.O.P.-04-2022.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-05-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/BASES CAASIM-HGO-L.O.P.-05-2022.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-06-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/BASES CAASIM-HGO-L.O.P.-06-2022.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-07-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/BASES CAASIM-HGO-L.O.P.-07-2022.pdf",
        },
      ],
      [
        "BASES EA-913005999-N1-2022 CEMENTO Y PRODUCTOS DE CONCRETO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N1-2022 CEMENTO Y PRODUCTOS DE CONCRETO.doc",
        },
      ],
      [
        "BASES EA-913005999-N10-2022 FIBRAS SINTETICAS, HULES, PLÁSTICOS Y DERIVADOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N10-2022 FIBRAS SINTETICAS, HULES, PLÁSTICOS Y DERIVADOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N11-2022 MATERIAL ELECTRICO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N11-2022 MATERIAL ELECTRICO.doc",
        },
      ],
      [
        "BASES EA-913005999-N12-2021 ARTÍCULOS METÁLICOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N12-2021 ARTÍCULOS METÁLICOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N13-2022 VEHICULOS Y EQUIPOS TERRESTRES RECURSO FISCAL",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N13-2022 VEHICULOS Y EQUIPOS TERRESTRES RECURSO FISCAL.doc",
        },
      ],
      [
        "BASES EA-913005999-N14-2022 CAPACITACIÓN",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N14-2022 CAPACITACIÓN.doc",
        },
      ],
      [
        "BASES EA-913005999-N15-2022 CAPACITACIÓN",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N15-2022 CAPACITACIÓN.doc",
        },
      ],
      [
        "BASES EA-913005999-N16-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N16-2022.doc",
        },
      ],
      [
        "BASES EA-913005999-N17-DISEÑO Y EJECUCION DE METODOLOGIA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N17-DISEÑO Y EJECUCION DE METODOLOGIA.doc",
        },
      ],
      [
        "BASES EA-913005999-N18-2022 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL SEGUNDO PROCEDIMIENTO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N18-2022 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL SEGUNDO PROCEDIMIENTO.doc",
        },
      ],
      [
        "BASES EA-913005999-N19-2022 MATERIAL DE OFICINA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N19-2022 MATERIAL DE OFICINA.doc",
        },
      ],
      [
        "BASES EA-913005999-N2-2022 TRASLADO DE VALORES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N2-2022 TRASLADO DE VALORES.doc",
        },
      ],
      [
        "BASES EA-913005999-N20-2022 MATERIAL DE LIMPIEZA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N20-2022 MATERIAL DE LIMPIEZA.doc",
        },
      ],
      [
        "BASES EA-913005999-N21-2022 SERVICIOS DE INFORMATICA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N21-2022 SERVICIOS DE INFORMATICA.doc",
        },
      ],
      [
        "BASES EA-913005999-N22-DISEÑO Y EJECUCION DE METODOLOGIA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N22-DISEÑO Y EJECUCION DE METODOLOGIA.doc",
        },
      ],
      [
        "BASES EA-913005999-N23-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N23-2022.doc",
        },
      ],
      [
        "BASES EA-913005999-N23-2022 SERVICIOS INTEGRALES (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N23-2022 SERVICIOS INTEGRALES (SEGUNDO PROCEDIMIENTO).doc",
        },
      ],
      [
        "BASES EA-913005999-N24-2022 CAPACITACIÓN (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N24-2022 CAPACITACIÓN (SEGUNDO PROCEDIMIENTO).doc",
        },
      ],
      [
        "BASES EA-913005999-N25-2022 FLETES Y MANIOBRAS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N25-2022 FLETES Y MANIOBRAS.doc",
        },
      ],
      [
        "BASES EA-913005999-N26-2022 ARRENDAMIENTO DE MAQUINARIA OTROS EQUIPOS Y HERRAMIENTAS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N26-2022 ARRENDAMIENTO DE MAQUINARIA OTROS EQUIPOS Y HERRAMIENTAS.doc",
        },
      ],
      [
        "BASES EA-913005999-N27-2022 NV",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N27-2022 NV.docx",
        },
      ],
      [
        "BASES EA-913005999-N28-2022 SUSTANCIAS QUIMICAS",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N28-2022 SUSTANCIAS QUIMICAS.docx",
        },
      ],
      [
        "BASES EA-913005999-N29-2022 OTROS MATERIALES ",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N29-2022 OTROS MATERIALES .docx",
        },
      ],
      [
        "BASES EA-913005999-N3-2021 VEHICULOS Y EQUIPOS TERRESTRES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N3-2021 VEHICULOS Y EQUIPOS TERRESTRES.doc",
        },
      ],
      [
        "BASES EA-913005999-N30-2022 HERRAMIENTAS MENORES",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N30-2022 HERRAMIENTAS MENORES.docx",
        },
      ],
      [
        "BASES EA-913005999-N31-2022 MATERIAL ELECTRICO",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N31-2022 MATERIAL ELECTRICO.docx",
        },
      ],
      [
        "BASES EA-913005999-N32-2022 FLETES Y MANIOBRAS SEGUNDO PROCEDIMIENTO",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N32-2022 FLETES Y MANIOBRAS SEGUNDO PROCEDIMIENTO.docx",
        },
      ],
      [
        "BASES EA-913005999-N33-2022 HERRAMIENTAS Y MAQUINAS HERRAMIENTAS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N33-2022 HERRAMIENTAS Y MAQUINAS HERRAMIENTAS.doc",
        },
      ],
      [
        "BASES EA-913005999-N34-2022 AQUISICION MATERIAL PARA EQUIPO DE DESAZOLVE",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N34-2022 AQUISICION MATERIAL PARA EQUIPO DE DESAZOLVE.docx",
        },
      ],
      [
        "BASES EA-913005999-N35-2022 OTROS EQUIPOS",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N35-2022 OTROS EQUIPOS.docx",
        },
      ],
      [
        "BASES EA-913005999-N36-2022 ESTUDIOS E INVESTIGACIONES",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N36-2022 ESTUDIOS E INVESTIGACIONES.docx",
        },
      ],
      [
        "BASES EA-913005999-N37-2022 FIBRAS SINTETICAS, HULES, PLÁSTICOS Y DERIVADOS",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N37-2022 FIBRAS SINTETICAS, HULES, PLÁSTICOS Y DERIVADOS.docx",
        },
      ],
      [
        "BASES EA-913005999-N38-2022 SUSTANCIAS QUIMICAS SEGUNDO PROCEDIMIENTO (1)",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N38-2022 SUSTANCIAS QUIMICAS SEGUNDO PROCEDIMIENTO (1).docx",
        },
      ],
      [
        "BASES EA-913005999-N39-2022 ROLLOS TÉRMICOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N39-2022 ROLLOS TÉRMICOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N4-2022 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N4-2022 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA.doc",
        },
      ],
      [
        "BASES EA-913005999-N40-2022 LICENCIAS INFORMÁTICAS E INTELECTUALES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N40-2022 LICENCIAS INFORMÁTICAS E INTELECTUALES.doc",
        },
      ],
      [
        "BASES EA-913005999-N41-2022 BIENES INFORMATICOS",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N41-2022 BIENES INFORMATICOS.docx",
        },
      ],
      [
        "BASES EA-913005999-N42-2022 ARTÍCULOS METÁLICOS PARA LA CONSTRUCCION",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N42-2022 ARTÍCULOS METÁLICOS PARA LA CONSTRUCCION.doc",
        },
      ],
      [
        "BASES EA-913005999-N43-2022 SUMINISTRO DE CABLE",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N43-2022 SUMINISTRO DE CABLE.docx",
        },
      ],
      [
        "BASES EA-913005999-N44-2022 ADQ DE MAT PARA LA REH MINAS SAN REYES Y ÁLAMO EL INCRE CDL DE EXTRAC",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N44-2022 ADQ DE MAT PARA LA REH MINAS SAN REYES Y ÁLAMO EL INCRE CDL DE EXTRAC.docx",
        },
      ],
      [
        "BASES EA-913005999-N45-2022 SUMINISTRO DE MEDIO FILTRANTE (1)",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N45-2022 SUMINISTRO DE MEDIO FILTRANTE (1).docx",
        },
      ],
      [
        "BASES EA-913005999-N46-2022 MEDIDORES DE MEDIA",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N46-2022 MEDIDORES DE MEDIA.docx",
        },
      ],
      [
        "BASES EA-913005999-N5-2022 PRODUCTOS MINERALES NO METALICOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N5-2022 PRODUCTOS MINERALES NO METALICOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N7-2022 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N7-2022 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL.doc",
        },
      ],
      [
        "BASES EA-913005999-N8-2022 VESTUARIO Y UNIFORMES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N8-2022 VESTUARIO Y UNIFORMES.doc",
        },
      ],
      [
        "BASES EA-913005999-N9-2022 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS (1)",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/BASES EA-913005999-N9-2022 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS (1).doc",
        },
      ],
      [
        "Bases Lic Adq Federal E2-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/Bases Lic Adq Federal E2-2022.doc",
        },
      ],
      [
        "Bases Lic Adq Federal E3-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/Bases Lic Adq Federal E3-2022.doc",
        },
      ],
      [
        "Bases Lic Adq Federal E4-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/Bases Lic Adq Federal E4-2022.doc",
        },
      ],
      [
        "CATALOGO CAASIM -HGO-L.O.P.-06-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/CATALOGO CAASIM -HGO-L.O.P.-06-2022.pdf",
        },
      ],
      [
        "CATALOGO CAASIM-HGO-L.O.P.--03-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/CATALOGO CAASIM-HGO-L.O.P.--03-2022.pdf",
        },
      ],
      [
        "CATALOGO CAASIM-HGO-L.O.P.-01-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/CATALOGO CAASIM-HGO-L.O.P.-01-2022.pdf",
        },
      ],
      [
        "CATALOGO CAASIM-HGO-L.O.P.-02-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/CATALOGO CAASIM-HGO-L.O.P.-02-2022.pdf",
        },
      ],
      [
        "CATALOGO CAASIM-HGO-L.O.P.-04-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/CATALOGO CAASIM-HGO-L.O.P.-04-2022.pdf",
        },
      ],
      [
        "CATALOGO CAASIM-HGO-L.O.P.-05-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/CATALOGO CAASIM-HGO-L.O.P.-05-2022.pdf",
        },
      ],
      [
        "CATALOGO CAASIM-HGO-L.O.P.-07-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/CATALOGO CAASIM-HGO-L.O.P.-07-2022.pdf",
        },
      ],
      [
        "CONV. 8-2022",
        { text: ".pdf", link: "/CAASIM/licitaciones/2022/CONV. 8-2022.pdf" },
      ],
      [
        "CONVOCATORIA MULTIPLE 01-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/CONVOCATORIA MULTIPLE 01-2022.pdf",
        },
      ],
      [
        "Convocatoria 04-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/Convocatoria 04-2022.doc",
        },
      ],
      [
        "Convocatoria 1-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/Convocatoria 1-2022.doc",
        },
      ],
      [
        "Convocatoria 10-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/Convocatoria 10-2022.doc",
        },
      ],
      [
        "Convocatoria 13-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/Convocatoria 13-2022.doc",
        },
      ],
      [
        "Convocatoria 3-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/Convocatoria 3-2022.doc",
        },
      ],
      [
        "Convocatoria 5-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/Convocatoria 5-2022.pdf",
        },
      ],
      [
        "Convocatoria 6-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/Convocatoria 6-2022.doc",
        },
      ],
      [
        "Convocatoria 7-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/Convocatoria 7-2022.doc",
        },
      ],
      [
        "Convocatoria 9-2022",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2022/Convocatoria 9-2022.doc",
        },
      ],
      [
        "Convocatoria Lic Adq Federal E2-E4 2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/Convocatoria Lic Adq Federal E2-E4 2022.pdf",
        },
      ],
      [
        "EA-913005999-N33-2022 HERRAMIENTAS Y MAQUINAS HERRAMIENTAS001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/EA-913005999-N33-2022 HERRAMIENTAS Y MAQUINAS HERRAMIENTAS001.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-01-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO CAASIM-HGO-L.O.P.-01-2022.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-02-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO CAASIM-HGO-L.O.P.-02-2022.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-03-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO CAASIM-HGO-L.O.P.-03-2022.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-04-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO CAASIM-HGO-L.O.P.-04-2022.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-05-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO CAASIM-HGO-L.O.P.-05-2022.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-06-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO CAASIM-HGO-L.O.P.-06-2022.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-07-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO CAASIM-HGO-L.O.P.-07-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N10-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N10-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N10-2022 DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N10-2022 DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N11-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N11-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N12-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N12-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N12-2022 DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N12-2022 DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N13-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N13-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N14-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N14-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N15-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N15-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N15-2022 DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N15-2022 DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N16-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N16-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N16-2022 DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N16-2022 DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N17-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N17-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N17-2022 DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N17-2022 DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N19-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N19-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N20-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N20-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N21-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N21-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N21-2022 DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N21-2022 DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N22-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N22-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N23-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N23-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N24-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N24-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N25-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N25-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N26-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N26-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N27-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N27-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N28-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N28-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N29-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N29-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N29-2022 diferido_001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N29-2022 diferido_001.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N3-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N3-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N30-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N30-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N30-2022 DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N30-2022 DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N31-2022 DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N31-2022 DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N31-2022_001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N31-2022_001.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N32-2022_001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N32-2022_001.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N33-2022 diferido",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N33-2022 diferido.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N34-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N34-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N34-2022_001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N34-2022_001.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N36-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N36-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N37-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N37-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N37-2022diferido",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N37-2022diferido.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N38-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N38-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N39-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N39-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N40-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N40-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N41-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N41-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N42-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N42-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N42-2022 DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N42-2022 DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N43-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N43-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N44-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N44-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N45-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N45-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N45-2022 final",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N45-2022 final.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N6-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N6-2022.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N7-2022 DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N7-2022 DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N8-2022 DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N8-2022 DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N9-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO EA-913005999-N9-2022.pdf",
        },
      ],
      [
        "FALLO LPN EA-913005999-N7-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO LPN EA-913005999-N7-2022.pdf",
        },
      ],
      [
        "FALLO LPN EA-913005999-N8-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO LPN EA-913005999-N8-2022.pdf",
        },
      ],
      [
        "FALLO No. EA-913005999-N20-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/FALLO No. EA-913005999-N20-2021.pdf",
        },
      ],
      [
        "Fallo No. EA-913005999-N21-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/Fallo No. EA-913005999-N21-2021.pdf",
        },
      ],
      [
        "JUNTA ACLARACIONES ITP-CAASIM-SRM-DL-06-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA ACLARACIONES ITP-CAASIM-SRM-DL-06-2022.pdf",
        },
      ],
      [
        "JUNTA APERTURA TECNICA ECONOMICA EA-93005999-N23-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA APERTURA TECNICA ECONOMICA EA-93005999-N23-2022.pdf",
        },
      ],
      [
        "JUNTA APERTURA TECNICA Y ECONOMICA EA-913005999-N18-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA APERTURA TECNICA Y ECONOMICA EA-913005999-N18-2022.pdf",
        },
      ],
      [
        "JUNTA APERTURA TECNICA Y ECONOMICA EA-913005999-N19-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA APERTURA TECNICA Y ECONOMICA EA-913005999-N19-2022.pdf",
        },
      ],
      [
        "JUNTA APERTURA TECNICA Y ECONOMICA EA-913005999-N20-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA APERTURA TECNICA Y ECONOMICA EA-913005999-N20-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACION EA-91300599-N16-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACION EA-91300599-N16-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACION EA-913005999-N15-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACION EA-913005999-N15-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACION EA-913005999-N29-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACION EA-913005999-N29-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES  EA-913005999-N45-2022 MEDIO FILTRANTE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES  EA-913005999-N45-2022 MEDIO FILTRANTE.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-05-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-05-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-06-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-06-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-07-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-07-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-91300599-N17-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-91300599-N17-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-91300599-N18-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-91300599-N18-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-91300599-N19-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-91300599-N19-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-91300599-N20-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-91300599-N20-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-91300599-N21-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-91300599-N21-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-91300599-N22-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-91300599-N22-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-91300599-N23-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-91300599-N23-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-91300599-N24-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-91300599-N24-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N10-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N10-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N11-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N11-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N12-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N12-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N13-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N13-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N25-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N25-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N26-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N26-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N27-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N27-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N28-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N28-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N30-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N30-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N31-2022 MATERIAL ELECTRICO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N31-2022 MATERIAL ELECTRICO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N32-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N32-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N34-2022 EQUIPOS DE DESAZOLVE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N34-2022 EQUIPOS DE DESAZOLVE.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N35-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N35-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N36-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N36-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N37-2022 FIBRAS SINTETICAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N37-2022 FIBRAS SINTETICAS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N38-2022 SUSTANCIAS QUIMICAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N38-2022 SUSTANCIAS QUIMICAS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N39-2022 rollos termicos",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N39-2022 rollos termicos.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N40-2022 licencias informatic",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N40-2022 licencias informatic.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N41-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N41-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N42-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N42-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N43-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N43-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N44-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N44-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N6-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N6-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N7-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N7-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N8-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N8-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N9-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES EA-913005999-N9-2022.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES LPN EA-913005999-N14-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE ACLARACIONES LPN EA-913005999-N14-2022.pdf",
        },
      ],
      [
        "JUNTA DE APERTURA TECNICA ECONOMICA EA-93005999-N21-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE APERTURA TECNICA ECONOMICA EA-93005999-N21-2022.pdf",
        },
      ],
      [
        "JUNTA DE APERTURA TECNICA ECONOMICA EA-93005999-N22-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE APERTURA TECNICA ECONOMICA EA-93005999-N22-2022.pdf",
        },
      ],
      [
        "JUNTA DE APERTURA TECNICA ECONOMICA EA-93005999-N24-2022",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/JUNTA DE APERTURA TECNICA ECONOMICA EA-93005999-N24-2022.pdf",
        },
      ],
      [
        "ZONIFICACION BACHEO Z-1",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/ZONIFICACION BACHEO Z-1.pdf",
        },
      ],
      [
        "ZONIFICACION BACHEO Z-2",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/ZONIFICACION BACHEO Z-2.pdf",
        },
      ],
      [
        "ZONIFICACION BACHEO Z-3",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/ZONIFICACION BACHEO Z-3.pdf",
        },
      ],
      [
        "ZONIFICACION BACHEO Z-4",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2022/ZONIFICACION BACHEO Z-4.pdf",
        },
      ],
    ],
  },

  // SECTION 2021
  {
    anio: "2021",
    icono: "fa fa-file-text-o fa-2x",
    formatos: [
      [
        "A-E-R CAASIM-DAJ-191-2020",
        {
          text: ".PDF",
          link: "/CAASIM/licitaciones/2021/A-E-R CAASIM-DAJ-191-2020.PDF",
        },
      ],
      [
        "A-E-R CAASIM-DAJ-192-2020",
        {
          text: ".PDF",
          link: "/CAASIM/licitaciones/2021/A-E-R CAASIM-DAJ-192-2020.PDF",
        },
      ],
      [
        "ACLARACIONES  EA-913005999-N22-2021 OTROS EQUIPOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACLARACIONES  EA-913005999-N22-2021 OTROS EQUIPOS.pdf",
        },
      ],
      [
        "ACLARACIONES  EA-913005999-N23-202 LICENCIAS INFORMÁTICAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACLARACIONES  EA-913005999-N23-202 LICENCIAS INFORMÁTICAS.pdf",
        },
      ],
      [
        "ACLARACIONES  EA-913005999-N24-202EQUIPOS Y APARATOS DE COM Y TE",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACLARACIONES  EA-913005999-N24-202EQUIPOS Y APARATOS DE COM Y TE.pdf",
        },
      ],
      [
        "ACLARACIONES  EA-913005999-N26-2021 SERVICIOS DE INFORMÁTICA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACLARACIONES  EA-913005999-N26-2021 SERVICIOS DE INFORMÁTICA.pdf",
        },
      ],
      [
        "ACLARACIONES  EA-913005999-N27-2021 OTROS MATERIALES Y ART_",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACLARACIONES  EA-913005999-N27-2021 OTROS MATERIALES Y ART_.pdf",
        },
      ],
      [
        "ACLARACIONES EA-913005999-N25-2021 FIBRAS SINTÉTICAS, HULES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACLARACIONES EA-913005999-N25-2021 FIBRAS SINTÉTICAS, HULES.pdf",
        },
      ],
      [
        "ACLARACIONES EA-913005999-N29-2021MATERIAL ELECTRICO 2DO. PROCED",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACLARACIONES EA-913005999-N29-2021MATERIAL ELECTRICO 2DO. PROCED.pdf",
        },
      ],
      [
        "ACTA APERTURA EA-913005999-N10-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA APERTURA EA-913005999-N10-2021.pdf",
        },
      ],
      [
        "ACTA APERTURA EA-913005999-N12-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA APERTURA EA-913005999-N12-2021.pdf",
        },
      ],
      [
        "ACTA APERTURA EA-913005999-N9-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA APERTURA EA-913005999-N9-2021.pdf",
        },
      ],
      [
        "ACTA APERTURA EA913005999-N7-2021001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA APERTURA EA913005999-N7-2021001.pdf",
        },
      ],
      [
        "ACTA APERTURA EA913005999-N8-2021001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA APERTURA EA913005999-N8-2021001.pdf",
        },
      ],
      [
        "ACTA DE APERTURA EA-913005999-N11-2021001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE APERTURA EA-913005999-N11-2021001.pdf",
        },
      ],
      [
        "ACTA DE APERTURA EA-913005999-N26-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE APERTURA EA-913005999-N26-2021.pdf",
        },
      ],
      [
        "ACTA DE APERTURA TECNICA Y ECONOMICA EA-913005999-N1-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE APERTURA TECNICA Y ECONOMICA EA-913005999-N1-2021.pdf",
        },
      ],
      [
        "ACTA DE FALLO EA-913005999-N11-2021001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE FALLO EA-913005999-N11-2021001.pdf",
        },
      ],
      [
        "ACTA DE FALLO EA-913005999-N24-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE FALLO EA-913005999-N24-2021.pdf",
        },
      ],
      [
        "ACTA DE FALLO EA-913005999-N29-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE FALLO EA-913005999-N29-2021.pdf",
        },
      ],
      [
        "ACTA DE FALLO LPN EA-913005999-N25-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE FALLO LPN EA-913005999-N25-2021.pdf",
        },
      ],
      [
        "ACTA DE FALLO N-10 EQUIPOS DE GENERACIÓN ELECTRICA, APARATOS....001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE FALLO N-10 EQUIPOS DE GENERACIÓN ELECTRICA, APARATOS....001.pdf",
        },
      ],
      [
        "ACTA DE FALLO N-7 REFACCIONES Y ACCESORIOS MENORES001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE FALLO N-7 REFACCIONES Y ACCESORIOS MENORES001.pdf",
        },
      ],
      [
        "ACTA DE FALLO N-8 HERRAMIENTAS Y MAQUINAS HERRAMIENTA001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE FALLO N-8 HERRAMIENTAS Y MAQUINAS HERRAMIENTA001.pdf",
        },
      ],
      [
        "ACTA DE FALLO N-9 MAQUINARIA Y EQUIPO INDUSTRIAL001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE FALLO N-9 MAQUINARIA Y EQUIPO INDUSTRIAL001.pdf",
        },
      ],
      [
        "ACTA DE FALLO N12-2021 HERRAMIENTAS MENORES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE FALLO N12-2021 HERRAMIENTAS MENORES.pdf",
        },
      ],
      [
        "ACTA DE PRESENTACIÓN Y APERTURA EA-913005999-N18-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/ACTA DE PRESENTACIÓN Y APERTURA EA-913005999-N18-2021.pdf",
        },
      ],
      [
        "APERTURA N-13 MATERIAL DE LIMPIEZA001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/APERTURA N-13 MATERIAL DE LIMPIEZA001.pdf",
        },
      ],
      [
        "APERTURA N-14 ARTÍCULOS METÁLICOS PARA LA CONSTRUCCIÓN001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/APERTURA N-14 ARTÍCULOS METÁLICOS PARA LA CONSTRUCCIÓN001.pdf",
        },
      ],
      [
        "APERTURA N-15-2021MERCANCIAS ADQUIRIDAS PARA SU COM",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/APERTURA N-15-2021MERCANCIAS ADQUIRIDAS PARA SU COM.pdf",
        },
      ],
      [
        "APERTURA N-16 MATERIAL Y UTILES CONSUMIBLES001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/APERTURA N-16 MATERIAL Y UTILES CONSUMIBLES001.pdf",
        },
      ],
      [
        "APERTURA N17-2021 MATERIAL DE OFICINA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/APERTURA N17-2021 MATERIAL DE OFICINA.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N2-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/APERTURA TECNICA Y ECONOMICA EA-913005999-N2-2021.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N28-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/APERTURA TECNICA Y ECONOMICA EA-913005999-N28-2021.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N30-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/APERTURA TECNICA Y ECONOMICA EA-913005999-N30-2021.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N4-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/APERTURA TECNICA Y ECONOMICA EA-913005999-N4-2021.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N48-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/APERTURA TECNICA Y ECONOMICA EA-913005999-N48-2020.pdf",
        },
      ],
      [
        "Acta de Junta de Aclaraciones EA-913005999-N3-2021001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/Acta de Junta de Aclaraciones EA-913005999-N3-2021001.pdf",
        },
      ],
      [
        "BASES EA-913005999-N1-2021 FORMAS VALORADAS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N1-2021 FORMAS VALORADAS.doc",
        },
      ],
      [
        "BASES EA-913005999-N10-2021 Equipos de generación eléctrica, aparatos y accesorios",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N10-2021 Equipos de generación eléctrica, aparatos y accesorios.doc",
        },
      ],
      [
        "BASES EA-913005999-N11-SERVICIOS DE INFORMÁTICA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N11-SERVICIOS DE INFORMÁTICA.doc",
        },
      ],
      [
        "BASES EA-913005999-N12HERRAMIENTAS MENORES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N12HERRAMIENTAS MENORES.doc",
        },
      ],
      [
        "BASES EA-913005999-N13-2021 MATERIAL DE LIMPIEZA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N13-2021 MATERIAL DE LIMPIEZA.doc",
        },
      ],
      [
        "BASES EA-913005999-N14-2021 Artículos Metalicos para la construcción",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N14-2021 Artículos Metalicos para la construcción.doc",
        },
      ],
      [
        "BASES EA-913005999-N15-2021 MEDIDORES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N15-2021 MEDIDORES.doc",
        },
      ],
      [
        "BASES EA-913005999-N16-2021 MATERIALES Y UTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFORMÁTICOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N16-2021 MATERIALES Y UTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFORMÁTICOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N17-2021 MATERIAL DE OFICINA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N17-2021 MATERIAL DE OFICINA.doc",
        },
      ],
      [
        "BASES EA-913005999-N18-SERVICIOS DE INFORMÁTICA SEGUNDO PROCEDIMIENTO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N18-SERVICIOS DE INFORMÁTICA SEGUNDO PROCEDIMIENTO.doc",
        },
      ],
      [
        "BASES EA-913005999-N19-2021 MATERIAL ELÉCTRICO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N19-2021 MATERIAL ELÉCTRICO.doc",
        },
      ],
      [
        "BASES EA-913005999-N2-2021 VESTUARIO Y UNIFORMES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N2-2021 VESTUARIO Y UNIFORMES.doc",
        },
      ],
      [
        "BASES EA-913005999-N20-2021 MAQUINARIA Y EQUIPO INDUSTRIAL",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N20-2021 MAQUINARIA Y EQUIPO INDUSTRIAL.doc",
        },
      ],
      [
        "BASES EA-913005999-N21-2021 BIENES INFORMÁTICOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N21-2021 BIENES INFORMÁTICOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N22-OTROS EQUIPOS ",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N22-OTROS EQUIPOS .docx",
        },
      ],
      [
        "BASES EA-913005999-N23-2021 LICENCIAS INFORMATICAS E INTELECTUALES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N23-2021 LICENCIAS INFORMATICAS E INTELECTUALES.doc",
        },
      ],
      [
        "BASES EA-913005999-N24 EQUIPOS Y APARATOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N24 EQUIPOS Y APARATOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N25-2021 FIBRAS SINTETICAS, HULES, PLÁSTICOS Y DERIVADOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N25-2021 FIBRAS SINTETICAS, HULES, PLÁSTICOS Y DERIVADOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N26-SERVICIOS DE INFORMÁTICA ",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N26-SERVICIOS DE INFORMÁTICA .doc",
        },
      ],
      [
        "BASES EA-913005999-N27-2021 OTROS MATERIALES Y ARTÍCULOS DE CONSTRUCCIÓN Y REPARACIÓN",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N27-2021 OTROS MATERIALES Y ARTÍCULOS DE CONSTRUCCIÓN Y REPARACIÓN.doc",
        },
      ],
      [
        "BASES EA-913005999-N28-2021 AUDITORIA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N28-2021 AUDITORIA.doc",
        },
      ],
      [
        "BASES EA-913005999-N29-2021 MATERIAL ELÉCTRICO (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N29-2021 MATERIAL ELÉCTRICO (SEGUNDO PROCEDIMIENTO).doc",
        },
      ],
      [
        "BASES EA-913005999-N3-2021 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N3-2021 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL.doc",
        },
      ],
      [
        "BASES EA-913005999-N30-2021 MEDIDORES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N30-2021 MEDIDORES.doc",
        },
      ],
      [
        "BASES EA-913005999-N31-2021 SUSTANCIAS QUIMICAS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N31-2021 SUSTANCIAS QUIMICAS.doc",
        },
      ],
      [
        "BASES EA-913005999-N32-2021 OTROS EQUIPOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N32-2021 OTROS EQUIPOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N33-2021 SERVICIOS DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIONES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N33-2021 SERVICIOS DE APOYO ADMINISTRATIVO, FOTOCOPIADO E IMPRESIONES.doc",
        },
      ],
      [
        "BASES EA-913005999-N34-2021 FIBRAS SINTETICAS, HULES, PLÁSTICOS Y DERIVADOS (SEGUNDO PROCEDIMEIENTO)",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N34-2021 FIBRAS SINTETICAS, HULES, PLÁSTICOS Y DERIVADOS (SEGUNDO PROCEDIMEIENTO).doc",
        },
      ],
      [
        "BASES EA-913005999-N4-FIBRAS SINTÉTICAS, HULES, PLÁSTICOS Y DERIVADOS ",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N4-FIBRAS SINTÉTICAS, HULES, PLÁSTICOS Y DERIVADOS .doc",
        },
      ],
      [
        "BASES EA-913005999-N48-2019 SUSTANCIAS QUIMICAS SEGUNDO PROCEDIMIENTO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N48-2019 SUSTANCIAS QUIMICAS SEGUNDO PROCEDIMIENTO.doc",
        },
      ],
      [
        "BASES EA-913005999-N5-2021 OTROS EQUIPOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N5-2021 OTROS EQUIPOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N6-FIBRAS SINTÉTICAS, HULES, PLÁSTICOS Y DERIVADOS SEGUNDO PROCEDIMIENTO ",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N6-FIBRAS SINTÉTICAS, HULES, PLÁSTICOS Y DERIVADOS SEGUNDO PROCEDIMIENTO .doc",
        },
      ],
      [
        "BASES EA-913005999-N7-REFACCIONES Y ACCESORIOS MENORES OTROS EQUIPOS ",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N7-REFACCIONES Y ACCESORIOS MENORES OTROS EQUIPOS .doc",
        },
      ],
      [
        "BASES EA-913005999-N8-2021 HERRAMIENTAS Y MAQUINAS-HERRAMIENTA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N8-2021 HERRAMIENTAS Y MAQUINAS-HERRAMIENTA.doc",
        },
      ],
      [
        "BASES EA-913005999-N9-MAQUINARIA Y EQUIPO INDUSTRIAL ",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/BASES EA-913005999-N9-MAQUINARIA Y EQUIPO INDUSTRIAL .doc",
        },
      ],
      [
        "CONVOCATORIA ITP-02",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/CONVOCATORIA ITP-02.pdf",
        },
      ],
      [
        "CONVOCATORIA ITP-03",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/CONVOCATORIA ITP-03.pdf",
        },
      ],
      [
        "Convocatoria 01-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 01-2021.doc",
        },
      ],
      [
        "Convocatoria 02-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 02-2021.doc",
        },
      ],
      [
        "Convocatoria 03-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 03-2021.doc",
        },
      ],
      [
        "Convocatoria 04-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 04-2021.doc",
        },
      ],
      [
        "Convocatoria 05-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 05-2021.doc",
        },
      ],
      [
        "Convocatoria 07-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 07-2021.doc",
        },
      ],
      [
        "Convocatoria 08-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 08-2021.doc",
        },
      ],
      [
        "Convocatoria 09-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 09-2021.doc",
        },
      ],
      [
        "Convocatoria 10-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 10-2021.doc",
        },
      ],
      [
        "Convocatoria 11-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 11-2021.doc",
        },
      ],
      [
        "Convocatoria 12-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 12-2021.doc",
        },
      ],
      [
        "Convocatoria 13-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 13-2021.doc",
        },
      ],
      [
        "Convocatoria 14-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 14-2021.doc",
        },
      ],
      [
        "Convocatoria 15-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 15-2020.doc",
        },
      ],
      [
        "Convocatoria 15-2021",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2021/Convocatoria 15-2021.doc",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-08-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO CAASIM-HGO-L.O.P.-08-2020.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-09-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO CAASIM-HGO-L.O.P.-09-2020.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-10-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO CAASIM-HGO-L.O.P.-10-2020.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-11-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO CAASIM-HGO-L.O.P.-11-2020.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-12-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO CAASIM-HGO-L.O.P.-12-2020.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-13-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO CAASIM-HGO-L.O.P.-13-2020.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N22-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO DIFERIDO EA-913005999-N22-2021.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N30-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO DIFERIDO EA-913005999-N30-2021.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N32-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO DIFERIDO EA-913005999-N32-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N1-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N1-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N14-2021 ARTICULOS METALICOS PARA LA CONSTR",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N14-2021 ARTICULOS METALICOS PARA LA CONSTR.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N19-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N19-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N2-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N2-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N22-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N22-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N23-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N23-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N25-2021_DIFERIDO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N25-2021_DIFERIDO.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N26-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N26-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N27-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N27-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N3-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N3-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N30-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N30-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N31-2021001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N31-2021001.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N32-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N32-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N33-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N33-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N34-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N34-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N4-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N4-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N5-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N5-2021.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N6-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO EA-913005999-N6-2021.pdf",
        },
      ],
      [
        "FALLO FINAL  N12 1",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO FINAL  N12 1.pdf",
        },
      ],
      [
        "FALLO ITP-02",
        { text: ".pdf", link: "/CAASIM/licitaciones/2021/FALLO ITP-02.pdf" },
      ],
      [
        "FALLO ITP-03",
        { text: ".pdf", link: "/CAASIM/licitaciones/2021/FALLO ITP-03.pdf" },
      ],
      [
        "FALLO LPN EA-913005999-N25-2021 FIBRAS SINTETICAS, HULES, PLÁSTICOS Y DERIVADOS (DIFERIDA)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO LPN EA-913005999-N25-2021 FIBRAS SINTETICAS, HULES, PLÁSTICOS Y DERIVADOS (DIFERIDA).pdf",
        },
      ],
      [
        "FALLO N15-2021 MERCANCIAS ADQUIRIDAS PARA SU COMER.001",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO N15-2021 MERCANCIAS ADQUIRIDAS PARA SU COMER.001.pdf",
        },
      ],
      [
        "FALLO N18 SERVICIOS DE INFORMATICA SEGUNDO PROCEDIMIENTO20102021100828",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/FALLO N18 SERVICIOS DE INFORMATICA SEGUNDO PROCEDIMIENTO20102021100828.pdf",
        },
      ],
      [
        "Fallo No. EA-913005999-N28-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/Fallo No. EA-913005999-N28-2021.pdf",
        },
      ],
      [
        "Fallo No. EA-913005999-N34-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/Fallo No. EA-913005999-N34-2021.pdf",
        },
      ],
      [
        "IMAGENES DE LA PARTIDA 27 DE LA LPN EA-913005999-N34-2021 (PREGUNTA 2 DE JUNTA DE ACLARACIONES)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/IMAGENES DE LA PARTIDA 27 DE LA LPN EA-913005999-N34-2021 (PREGUNTA 2 DE JUNTA DE ACLARACIONES).pdf",
        },
      ],
      [
        "JUNTA ACLARACIONES EA-913005999-N1-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA ACLARACIONES EA-913005999-N1-2021.pdf",
        },
      ],
      [
        "JUNTA ACLARACIONES EA-913005999-N48-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA ACLARACIONES EA-913005999-N48-2020.pdf",
        },
      ],
      [
        "JUNTA ACLARACIONES ITP-02",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA ACLARACIONES ITP-02.pdf",
        },
      ],
      [
        "JUNTA ACLARACIONES ITP-03",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA ACLARACIONES ITP-03.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACION EA-913005999-N5-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACION EA-913005999-N5-2021.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2021.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-08-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-08-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-09-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-09-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-10-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-10-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-11-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-11-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-12-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-12-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-13-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-13-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-91300599-N6-2121",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-91300599-N6-2121.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N07-2021 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N07-2021 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES MUEBLES.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N08-2021 HERRAMIENTAS Y  MAQUINAS-HERRAMIENTA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N08-2021 HERRAMIENTAS Y  MAQUINAS-HERRAMIENTA.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N09-2021 MAQUINARIA Y EQUIPO INDUSTRIAL",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N09-2021 MAQUINARIA Y EQUIPO INDUSTRIAL.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N10-2021 EQUIPOS DE GENERACIÓN ELECTRICA Y ACCESORIOS ELÉCTRICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N10-2021 EQUIPOS DE GENERACIÓN ELECTRICA Y ACCESORIOS ELÉCTRICOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N11-2021 SERVICIOS DE INFORMATICA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N11-2021 SERVICIOS DE INFORMATICA.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N12-2021 HERRAMIENTAS MENORES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N12-2021 HERRAMIENTAS MENORES.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N18-2021 SERVICIOS DE INFORMATICA (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N18-2021 SERVICIOS DE INFORMATICA (SEGUNDO PROCEDIMIENTO).pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N19-2021 MATERIAL ELÉCTRICO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N19-2021 MATERIAL ELÉCTRICO.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N20-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N20-2021.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N21-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N21-2021.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N28 2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N28 2021.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N30-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N30-2021.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N31-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N31-2021.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N32-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N32-2021.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N33-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N33-2021.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N34-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N34-2021.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N4-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES EA-913005999-N4-2021.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES N-15 MERCANCIAS ADQUIRIDAS (MEDIDORES)",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES N-15 MERCANCIAS ADQUIRIDAS (MEDIDORES).pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES N-16 TONERS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES N-16 TONERS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES N-17 MATERIAL DE OFICINA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES N-17 MATERIAL DE OFICINA.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES N13-2021 MAT. DE LIMPIEZA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES N13-2021 MAT. DE LIMPIEZA.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES N14-2021 ARTÍCULOS METÁLICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES N14-2021 ARTÍCULOS METÁLICOS.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES_DIFERIDA_ EA-913005999-N31-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/JUNTA DE ACLARACIONES_DIFERIDA_ EA-913005999-N31-2021.pdf",
        },
      ],
      [
        "Junta de Aclaraciones EA-913005999-N2-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/Junta de Aclaraciones EA-913005999-N2-2021.pdf",
        },
      ],
      [
        "PANTONES DE LA LICITACIÓN  EA-913005999-N27-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PANTONES DE LA LICITACIÓN  EA-913005999-N27-2021.pdf",
        },
      ],
      [
        "PRESENTACION Y APERTURA CAASIM-HGO-L.O.P.-01-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACION Y APERTURA CAASIM-HGO-L.O.P.-01-2021.pdf",
        },
      ],
      [
        "PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N34-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N34-2021.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-08-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-08-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-09-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-09-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-10-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-10-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-11-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-11-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-12-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-12-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-13-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-13-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N19-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N19-2021.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N31-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N31-2021.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N32-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N32-2021.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N33-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N33-2021.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA EA-913005999-N3-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA EA-913005999-N3-2021.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA EA-913005999-N5-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA EA-913005999-N5-2021.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA EA-913005999-N6-2021",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN Y APERTURA EA-913005999-N6-2021.pdf",
        },
      ],
      [
        "PRESENTACIÓN-APERTURA ITP-02",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN-APERTURA ITP-02.pdf",
        },
      ],
      [
        "PRESENTACIÓN-APERTURA ITP-03",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/PRESENTACIÓN-APERTURA ITP-03.pdf",
        },
      ],
      [
        "Partida 1.- formato de recibo 1",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/Partida 1.- formato de recibo 1.pdf",
        },
      ],
      [
        "Partida 1.- formato de recibo 2",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/Partida 1.- formato de recibo 2.pdf",
        },
      ],
      [
        "Partida 2.- formato de solicitud de cambio al padron de usuarios",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/Partida 2.- formato de solicitud de cambio al padron de usuarios.pdf",
        },
      ],
      [
        "Partida 3.- formato de solicitud de servicio para agua potable y descarga sanitaria",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/Partida 3.- formato de solicitud de servicio para agua potable y descarga sanitaria.pdf",
        },
      ],
      [
        "Partida 4.- formato de informe de supervisión y verificación",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/Partida 4.- formato de informe de supervisión y verificación.pdf",
        },
      ],
      [
        "Partida 5.- formato de informe de instalación o sustitución",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/Partida 5.- formato de informe de instalación o sustitución.pdf",
        },
      ],
      [
        "fallo N3217122021094931",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2021/fallo N3217122021094931.pdf",
        },
      ],
    ],
  },
  // SECTION 2020
  {
    anio: "2020",
    icono: "fa fa-file-text-o fa-2x",
    formatos: [
      [
        "ACTA DE FALLO EA-913005999-N7-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/ACTA DE FALLO EA-913005999-N7-2020.pdf",
        },
      ],
      [
        "ACTA DE PROPUESTA TECNICA Y ECONOMICA EA-91300599-N20-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/ACTA DE PROPUESTA TECNICA Y ECONOMICA EA-91300599-N20-2020.pdf",
        },
      ],
      [
        "APERTURA DE PROP NO. EA-913005999-N13-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA DE PROP NO. EA-913005999-N13-2020.pdf",
        },
      ],
      [
        "APERTURA DE PROPOSICIONES EA-913005999-N7-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA DE PROPOSICIONES EA-913005999-N7-2020.pdf",
        },
      ],
      [
        "APERTURA DE PROPUESTAS TECNICA Y ECONOMICA EA-913005999-N01-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA DE PROPUESTAS TECNICA Y ECONOMICA EA-913005999-N01-2020.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N13-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA EA-913005999-N13-2020.pdf",
        },
      ],
      [
        "APERTURA EA-913005999-N9-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA EA-913005999-N9-2020.pdf",
        },
      ],
      [
        "APERTURA LICITACIÓN EA-913005999-N15-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA LICITACIÓN EA-913005999-N15-2020.pdf",
        },
      ],
      [
        "APERTURA TECNCA ECONOMICA  EA-91300599-N14-200",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNCA ECONOMICA  EA-91300599-N14-200.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA  EA-913005999-N2-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA  EA-913005999-N2-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA  EA-913005999-N3-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA  EA-913005999-N3-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N10-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N10-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N11-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N11-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N12-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N12-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N16-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N16-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N17-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N17-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N18-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N18-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N19-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N19-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N21-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N21-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N22-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N22-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N23-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N23-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N24-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N24-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N25-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N25-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N26-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N26-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N27-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N27-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N29-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N29-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N30-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N30-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N31-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N31-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N32-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N32-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N33-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N33-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N34-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N34-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N36-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N36-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N37-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N37-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N38-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N38-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N39-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N39-2020.pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA EA-913005999-N4-2020 2DO PROC.",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA EA-913005999-N4-2020 2DO PROC..pdf",
        },
      ],
      [
        "APERTURA TECNICA Y ECONOMICA N28-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/APERTURA TECNICA Y ECONOMICA N28-2020.pdf",
        },
      ],
      [
        "Apertura de Proposiciones EA-913005999-n8-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/Apertura de Proposiciones EA-913005999-n8-2020.pdf",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-01-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-01-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-02-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-02-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-03-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-03-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-04-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-04-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-05-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-05-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-06-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-06-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-07-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-07-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-08-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-08-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-09-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-09-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-10-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-10-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-11-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-11-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-12-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-12-2020.doc",
        },
      ],
      [
        "BASES CAASIM-HGO-L.O.P.-13-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES CAASIM-HGO-L.O.P.-13-2020.doc",
        },
      ],
      [
        "BASES EA-07-2020 EQUIPOS DE BOMBEO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-07-2020 EQUIPOS DE BOMBEO.doc",
        },
      ],
      [
        "BASES EA-08-2020 MACROMEDIDORES ULTRASÓNICOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-08-2020 MACROMEDIDORES ULTRASÓNICOS.doc",
        },
      ],
      [
        "BASES EA-09-2020 MACROMEDIDORES ULTRASÓNICOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-09-2020 MACROMEDIDORES ULTRASÓNICOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N1-2020 SERVICIO DE TRASLADO DE VALORES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N1-2020 SERVICIO DE TRASLADO DE VALORES.doc",
        },
      ],
      [
        "BASES EA-913005999-N10-2020 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N10-2020 REFACCIONES Y ACCESORIOS MENORES OTROS BIENES.doc",
        },
      ],
      [
        "BASES EA-913005999-N11-2020 OTROS EQUIPOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N11-2020 OTROS EQUIPOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N12-FIBRAS SINTÉTICAS, HULES, PLÁSTICOS Y DERIVADOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N12-FIBRAS SINTÉTICAS, HULES, PLÁSTICOS Y DERIVADOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N13-2020 HERRAMIENTAS Y MAQUINAS-HERRAMIENTA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N13-2020 HERRAMIENTAS Y MAQUINAS-HERRAMIENTA.doc",
        },
      ],
      [
        "BASES EA-913005999-N14-2020 MAQUINARIA Y EQUIPO INDUSTRIAL",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N14-2020 MAQUINARIA Y EQUIPO INDUSTRIAL.doc",
        },
      ],
      [
        "BASES EA-913005999-N15-2020 ARTÍCULOS METÁLICOS PARA LA CONSTRUCCIÓN",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N15-2020 ARTÍCULOS METÁLICOS PARA LA CONSTRUCCIÓN.doc",
        },
      ],
      [
        "BASES EA-913005999-N16-2020 MATERIAL DE OFICINA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N16-2020 MATERIAL DE OFICINA.doc",
        },
      ],
      [
        "BASES EA-913005999-N17-2020 MATERIALES Y ÚTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFORMATICOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N17-2020 MATERIALES Y ÚTILES CONSUMIBLES PARA EL PROCESAMIENTO EN EQUIPOS Y BIENES INFORMATICOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N18-2020 SUSTANCIAS QÍMICAS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N18-2020 SUSTANCIAS QÍMICAS.doc",
        },
      ],
      [
        "BASES EA-913005999-N19 -MATERIALES, ACCESORIOS Y SUMUNISTROS DE LABORATORIO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N19 -MATERIALES, ACCESORIOS Y SUMUNISTROS DE LABORATORIO.doc",
        },
      ],
      [
        "BASES EA-913005999-N2-2020 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N2-2020 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA.doc",
        },
      ],
      [
        "BASES EA-913005999-N20  MUEBLES DE OFICINA, ESTANTERÍA Y EQUIPO DE ADMINISTRACIÓN",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N20  MUEBLES DE OFICINA, ESTANTERÍA Y EQUIPO DE ADMINISTRACIÓN.doc",
        },
      ],
      [
        "BASES EA-913005999-N21-2020 OTROS MATERIALES Y ARÍCULOS DE CONSTRUCCIÓN Y REPARACIÓN",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N21-2020 OTROS MATERIALES Y ARÍCULOS DE CONSTRUCCIÓN Y REPARACIÓN.doc",
        },
      ],
      [
        "BASES EA-913005999-N22-2020 UNIFORMES, VESTUARIO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N22-2020 UNIFORMES, VESTUARIO.doc",
        },
      ],
      [
        "BASES EA-913005999-N23-2020 MATERIAL DE LIMPIEZA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N23-2020 MATERIAL DE LIMPIEZA.doc",
        },
      ],
      [
        "BASES EA-913005999-N24-2020 MEDIDORES DE MEDIA - 1",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N24-2020 MEDIDORES DE MEDIA - 1.doc",
        },
      ],
      [
        "BASES EA-913005999-N25-MATERIALES ELECTRICO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N25-MATERIALES ELECTRICO.doc",
        },
      ],
      [
        "BASES EA-913005999-N26-2020 HERRAMIENTAS MENORES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N26-2020 HERRAMIENTAS MENORES.doc",
        },
      ],
      [
        "BASES EA-913005999-N27-2020 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N27-2020 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL.doc",
        },
      ],
      [
        "BASES EA-913005999-N28",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N28.doc",
        },
      ],
      [
        "BASES EA-913005999-N29-2020 LICENCIAS INFORMÉTICAS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N29-2020 LICENCIAS INFORMÉTICAS.doc",
        },
      ],
      [
        "BASES EA-913005999-N3-2020 SUSTANCIAS QUIMICAS (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N3-2020 SUSTANCIAS QUIMICAS (SEGUNDO PROCEDIMIENTO).doc",
        },
      ],
      [
        "BASES EA-913005999-N30-2020 SUSTANCIAS QÍMICAS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N30-2020 SUSTANCIAS QÍMICAS.doc",
        },
      ],
      [
        "BASES EA-913005999-N31 MATERIALES, ACCESORIOS Y SUMUNISTROS DE LABORATORIO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N31 MATERIALES, ACCESORIOS Y SUMUNISTROS DE LABORATORIO.doc",
        },
      ],
      [
        "BASES EA-913005999-N32-2020 UNIFORMES, VESTUARIO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N32-2020 UNIFORMES, VESTUARIO.doc",
        },
      ],
      [
        "BASES EA-913005999-N33-2020 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N33-2020 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL.doc",
        },
      ],
      [
        "BASES EA-913005999-N34-2020 HERRAMIENTAS MENORES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N34-2020 HERRAMIENTAS MENORES.doc",
        },
      ],
      [
        "BASES EA-913005999-N35-2020 MATERIAL DE OFICINA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N35-2020 MATERIAL DE OFICINA.doc",
        },
      ],
      [
        "BASES EA-913005999-N36-MATERIALE ELECTRICO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N36-MATERIALE ELECTRICO.doc",
        },
      ],
      [
        "BASES EA-913005999-N37-2020 SERVICIOS DE AUDITORIA 2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N37-2020 SERVICIOS DE AUDITORIA 2020.doc",
        },
      ],
      [
        "BASES EA-913005999-N38-2020 BIENES INFORMATICOS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N38-2020 BIENES INFORMATICOS.doc",
        },
      ],
      [
        "BASES EA-913005999-N39-2020 SERVICIOS DE AUDITORIA 2020 segundo procedimiento",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N39-2020 SERVICIOS DE AUDITORIA 2020 segundo procedimiento.doc",
        },
      ],
      [
        "BASES EA-913005999-N4-2020 SERVICIO DE TRASLADO DE VALORES (SEGUNDO PROCEDIMIENTO)",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N4-2020 SERVICIO DE TRASLADO DE VALORES (SEGUNDO PROCEDIMIENTO).doc",
        },
      ],
      [
        "BASES EA-913005999-N40-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N40-2020.doc",
        },
      ],
      [
        "BASES EA-913005999-N41-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N41-2020.doc",
        },
      ],
      [
        "BASES EA-913005999-N42 -SEGUROS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N42 -SEGUROS.doc",
        },
      ],
      [
        "BASES EA-913005999-N43-2020 SERVICIO DE TRASLADO DE VALORES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N43-2020 SERVICIO DE TRASLADO DE VALORES.doc",
        },
      ],
      [
        "BASES EA-913005999-N44-2020 SUSTANCIAS QUIMICAS",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N44-2020 SUSTANCIAS QUIMICAS.doc",
        },
      ],
      [
        "BASES EA-913005999-N45-2020 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N45-2020 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA.doc",
        },
      ],
      [
        "BASES EA-913005999-N46-2020 SERVICIO DE TRASLADO DE VALORES",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N46-2020 SERVICIO DE TRASLADO DE VALORES.doc",
        },
      ],
      [
        "BASES EA-913005999-N47-2020 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA SEGUNDO PROCEDIMIENTO",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N47-2020 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA SEGUNDO PROCEDIMIENTO.doc",
        },
      ],
      [
        "BASES EA-913005999-N5-2020 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N5-2020 PRENDAS DE SEGURIDAD Y PROTECCIÓN PERSONAL.doc",
        },
      ],
      [
        "BASES EA-913005999-N6-2020 ACTUALIZACION DE MEJORAS A LOS SISTEMAS Y APPS UTILIZADOS POR LAS AREAS OPERATIVAS SOBRE",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/BASES EA-913005999-N6-2020 ACTUALIZACION DE MEJORAS A LOS SISTEMAS Y APPS UTILIZADOS POR LAS AREAS OPERATIVAS SOBRE.doc",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-01-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATALOGO MUDO CAASIM-HGO-L.O.P.-01-2020.xlsx",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-02-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATALOGO MUDO CAASIM-HGO-L.O.P.-02-2020.xlsx",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-03-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATALOGO MUDO CAASIM-HGO-L.O.P.-03-2020.xlsx",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-04-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATALOGO MUDO CAASIM-HGO-L.O.P.-04-2020.xlsx",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-05-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATALOGO MUDO CAASIM-HGO-L.O.P.-05-2020.xlsx",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-06-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATALOGO MUDO CAASIM-HGO-L.O.P.-06-2020.xlsx",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-07-2020",
        {
          text: ".docx",
          link: "/CAASIM/licitaciones/2020/CATALOGO MUDO CAASIM-HGO-L.O.P.-07-2020.docx",
        },
      ],
      [
        "CATALOGO MUDO CAASIM-HGO-L.O.P.-08-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATALOGO MUDO CAASIM-HGO-L.O.P.-08-2020.xlsx",
        },
      ],
      [
        "CATÁLOGO MUDO CAASIM-HGO-L.O.P.-09-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATÁLOGO MUDO CAASIM-HGO-L.O.P.-09-2020.xlsx",
        },
      ],
      [
        "CATÁLOGO MUDO CAASIM-HGO-L.O.P.-10-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATÁLOGO MUDO CAASIM-HGO-L.O.P.-10-2020.xlsx",
        },
      ],
      [
        "CATÁLOGO MUDO CAASIM-HGO-L.O.P.-11-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATÁLOGO MUDO CAASIM-HGO-L.O.P.-11-2020.xlsx",
        },
      ],
      [
        "CATÁLOGO MUDO CAASIM-HGO-L.O.P.-12-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATÁLOGO MUDO CAASIM-HGO-L.O.P.-12-2020.xlsx",
        },
      ],
      [
        "CATÁLOGO MUDO CAASIM-HGO-L.O.P.-13-2020",
        {
          text: ".xlsx",
          link: "/CAASIM/licitaciones/2020/CATÁLOGO MUDO CAASIM-HGO-L.O.P.-13-2020.xlsx",
        },
      ],
      [
        "CONVOCATORIA",
        { text: ".pdf", link: "/CAASIM/licitaciones/2020/CONVOCATORIA.pdf" },
      ],
      [
        "CONVOCATORIA CAASIM-HGO-L.O.P.-07-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/CONVOCATORIA CAASIM-HGO-L.O.P.-07-2020.pdf",
        },
      ],
      [
        "CONVOCATORIA MULTIPLE 01-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/CONVOCATORIA MULTIPLE 01-2020.pdf",
        },
      ],
      [
        "COVOCATRIA CAASIM-HGO-L.O.P.-06-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/COVOCATRIA CAASIM-HGO-L.O.P.-06-2020.pdf",
        },
      ],
      [
        "Convocatoria 01-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/Convocatoria 01-2020.doc",
        },
      ],
      [
        "Convocatoria 03-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/Convocatoria 03-2020.doc",
        },
      ],
      [
        "Convocatoria 04-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/Convocatoria 04-2020.doc",
        },
      ],
      [
        "Convocatoria 05-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/Convocatoria 05-2020.doc",
        },
      ],
      [
        "Convocatoria 06-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/Convocatoria 06-2020.doc",
        },
      ],
      [
        "Convocatoria 07-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/Convocatoria 07-2020.doc",
        },
      ],
      [
        "Convocatoria 08-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/Convocatoria 08-2020.doc",
        },
      ],
      [
        "Convocatoria 10-2020 -2",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/Convocatoria 10-2020 -2.doc",
        },
      ],
      [
        "Convocatoria 11-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/Convocatoria 11-2020.doc",
        },
      ],
      [
        "Convocatoria 12-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/Convocatoria 12-2020.doc",
        },
      ],
      [
        "Convocatoria 13-2020",
        {
          text: ".doc",
          link: "/CAASIM/licitaciones/2020/Convocatoria 13-2020.doc",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-01-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO CAASIM-HGO-L.O.P.-01-2020.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-01-2020.",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO CAASIM-HGO-L.O.P.-01-2020..pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-02-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO CAASIM-HGO-L.O.P.-02-2020.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-03-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO CAASIM-HGO-L.O.P.-03-2020.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-04-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO CAASIM-HGO-L.O.P.-04-2020.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-04-2020.",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO CAASIM-HGO-L.O.P.-04-2020..pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-05-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO CAASIM-HGO-L.O.P.-05-2020.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-06-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO CAASIM-HGO-L.O.P.-06-2020.pdf",
        },
      ],
      [
        "FALLO CAASIM-HGO-L.O.P.-07-2020.",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO CAASIM-HGO-L.O.P.-07-2020..pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N16-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO DIFERIDO EA-913005999-N16-2020.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N2-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO DIFERIDO EA-913005999-N2-2020.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N23-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO DIFERIDO EA-913005999-N23-2020.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N25-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO DIFERIDO EA-913005999-N25-2020.pdf",
        },
      ],
      [
        "FALLO DIFERIDO EA-913005999-N26-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO DIFERIDO EA-913005999-N26-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N1-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N1-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N10-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N10-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N11-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N11-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N12-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N12-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N13-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N13-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N13-2021 MATERIAL DE LIMPIEZA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N13-2021 MATERIAL DE LIMPIEZA.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N14-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N14-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N14-2021 ARTÍCULOS METÁLICOS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N14-2021 ARTÍCULOS METÁLICOS.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N15-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N15-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N15-2021MERCANCIAS ADQUIRIDAS PARA SU COMER.",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N15-2021MERCANCIAS ADQUIRIDAS PARA SU COMER..pdf",
        },
      ],
      [
        "FALLO EA-913005999-N16-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N16-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N16-2021 MATERIAL Y ÚTILES CONSUMIBLES",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N16-2021 MATERIAL Y ÚTILES CONSUMIBLES.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N17-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N17-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N17-2021 MATERIAL DE OFICINA",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N17-2021 MATERIAL DE OFICINA.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N18-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N18-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N19-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N19-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N2-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N2-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N20-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N20-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N21-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N21-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N22-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N22-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N23-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N23-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N24-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N24-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N25-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N25-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N26-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N26-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N27-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N27-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N28-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N28-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N29-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N29-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N3-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N3-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N30-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N30-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N31-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N31-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N32-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N32-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N33-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N33-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N34-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N34-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N35-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N35-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N36-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N36-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N37-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N37-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N38-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N38-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N39-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N39-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N4-2020 2DO PROC.",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N4-2020 2DO PROC..pdf",
        },
      ],
      [
        "FALLO EA-913005999-N40-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N40-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N41-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N41-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N42-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N42-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N43-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N43-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N44-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N44-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N46-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N46-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N47-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N47-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N8-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N8-2020.pdf",
        },
      ],
      [
        "FALLO EA-913005999-N9-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO EA-913005999-N9-2020.pdf",
        },
      ],
      [
        "FALLO ITP-CAASIM-SRMYSG-DC-03-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO ITP-CAASIM-SRMYSG-DC-03-2020.pdf",
        },
      ],
      [
        "FALLO NO EA-913005999-N5-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO NO EA-913005999-N5-2020.pdf",
        },
      ],
      [
        "FALLO NO EA-913005999-N6-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/FALLO NO EA-913005999-N6-2020.pdf",
        },
      ],
      [
        "JUNTA  ACLARACIONES EA-913005999-N43-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA  ACLARACIONES EA-913005999-N43-2020.pdf",
        },
      ],
      [
        "JUNTA  ACLARACIONES EA-913005999-N45-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA  ACLARACIONES EA-913005999-N45-2020.pdf",
        },
      ],
      [
        "JUNTA ACLARACIONES EA-913005999-N40-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA ACLARACIONES EA-913005999-N40-2020.pdf",
        },
      ],
      [
        "JUNTA ACLARACIONES EA-913005999-N41-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA ACLARACIONES EA-913005999-N41-2020.pdf",
        },
      ],
      [
        "JUNTA ACLARACIONES EA-913005999-N42-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA ACLARACIONES EA-913005999-N42-2020.pdf",
        },
      ],
      [
        "JUNTA ACLARACIONES EA-913005999-N44-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA ACLARACIONES EA-913005999-N44-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-05-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-05-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-06-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-06-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N1-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N1-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N10-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N10-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N11-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N11-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N12-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N12-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N13-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N13-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N14-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N14-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N15-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N15-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N16-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N16-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N17-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N17-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N18-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N18-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N19-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N19-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N2-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N2-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N20-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N20-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N21-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N21-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N22-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N22-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N23-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N23-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N24-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N24-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N25-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N25-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N26-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N26-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N27-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N27-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N28-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N28-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N29-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N29-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N3-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N3-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N30-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N30-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N31-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N31-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N32-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N32-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N33-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N33-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N34-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N34-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N35-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N35-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N36-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N36-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N37-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N37-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N38-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N38-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N39-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N39-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N46-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N46-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N47-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N47-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N5-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N5-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N6-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N6-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N7-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N7-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N8-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N8-2020.pdf",
        },
      ],
      [
        "JUNTA DE ACLARACIONES EA-913005999-N9-2020-2",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARACIONES EA-913005999-N9-2020-2.pdf",
        },
      ],
      [
        "JUNTA DE ACLARIONES CAASIM-HGO-L.O.P-07-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTA DE ACLARIONES CAASIM-HGO-L.O.P-07-2020.pdf",
        },
      ],
      [
        "JUNTAS DE ACLARACIONES EA-913005999-N4-2020 2DO PROCEDIMIENTO",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/JUNTAS DE ACLARACIONES EA-913005999-N4-2020 2DO PROCEDIMIENTO.pdf",
        },
      ],
      [
        "PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N46-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N46-2020.pdf",
        },
      ],
      [
        "PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N47-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N47-2020.pdf",
        },
      ],
      [
        "PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N5-2020 PRENDAS DE SEGURIDAD Y PROTECCION PERSONAL",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N5-2020 PRENDAS DE SEGURIDAD Y PROTECCION PERSONAL.pdf",
        },
      ],
      [
        "PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N6-2020 ACTUALIZACION DE MEJORAS A LOS SISTEMAS Y APPS UTILIZADOS POR LAS AREAS OPERATIVAS",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N6-2020 ACTUALIZACION DE MEJORAS A LOS SISTEMAS Y APPS UTILIZADOS POR LAS AREAS OPERATIVAS.pdf",
        },
      ],
      [
        "PRESENTACIÓN  Y APERTURA  EA-913005999-N38-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN  Y APERTURA  EA-913005999-N38-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-01-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-01-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-02-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-02-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-03-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-03-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-04-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-04-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-05-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-05-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-06-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-06-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N35-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N35-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APERURA CAASIM-HGO-L.O.P.-07-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APERURA CAASIM-HGO-L.O.P.-07-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N40-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N40-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N41-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N41-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N42-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N42-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N43-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N43-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N44-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N44-2020.pdf",
        },
      ],
      [
        "PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N45-2020",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/PRESENTACIÓN Y APÉRTURA DE PROPOSICIONES-N45-2020.pdf",
        },
      ],
      [
        "TERMINOS ACUEDUCTO ACTOPAN-PACHUCA 29.05",
        {
          text: ".pdf",
          link: "/CAASIM/licitaciones/2020/TERMINOS ACUEDUCTO ACTOPAN-PACHUCA 29.05.pdf",
        },
      ],
      [
        "ZONIFICACION CAASIM-HGO-L.O.P.-01-2020",
        {
          text: ".pptx",
          link: "/CAASIM/licitaciones/2020/ZONIFICACION CAASIM-HGO-L.O.P.-01-2020.pptx",
        },
      ],
      [
        "ZONIFICACION CAASIM-HGO-L.O.P.-02-2020",
        {
          text: ".pptx",
          link: "/CAASIM/licitaciones/2020/ZONIFICACION CAASIM-HGO-L.O.P.-02-2020.pptx",
        },
      ],
      [
        "ZONIFICACION CAASIM-HGO-L.O.P.-03-2020",
        {
          text: ".pptx",
          link: "/CAASIM/licitaciones/2020/ZONIFICACION CAASIM-HGO-L.O.P.-03-2020.pptx",
        },
      ],
      [
        "ZONIFICACION CAASIM-HGO-L.O.P.-04-2020",
        {
          text: ".pptx",
          link: "/CAASIM/licitaciones/2020/ZONIFICACION CAASIM-HGO-L.O.P.-04-2020.pptx",
        },
      ],
      [
        "ZONIFICACION z1",
        {
          text: ".pptx",
          link: "/CAASIM/licitaciones/2020/ZONIFICACION z1.pptx",
        },
      ],
      [
        "ZONIFICACION z2",
        {
          text: ".pptx",
          link: "/CAASIM/licitaciones/2020/ZONIFICACION z2.pptx",
        },
      ],
      [
        "ZONIFICACION z3",
        {
          text: ".pptx",
          link: "/CAASIM/licitaciones/2020/ZONIFICACION z3.pptx",
        },
      ],
      [
        "ZONIFICACION z4",
        {
          text: ".pptx",
          link: "/CAASIM/licitaciones/2020/ZONIFICACION z4.pptx",
        },
      ],
      [
        "convocatoria 09",
        { text: ".pdf", link: "/CAASIM/licitaciones/2020/convocatoria 09.pdf" },
      ],
    ],
  },
];
